import { createSlice } from "@reduxjs/toolkit";
import { Link } from "react-router-dom";

const initialState = [  
  {
    id: 92,
    title: "Поздравление Министра с Днем конституции",
    date: "14.03.2025",
    img: "/news/92/preview-cut.jpg",
    preParagraph: `Уважаемые коллеги, друзья!`,
    paragraph: `<div>
      <p><img src="/news/92/92.jpg" alt="Поздравление Министра с Днем конституции"></p> 
    `,
  },   
  {
    id: 91,
    title: "Поздравление с 8 марта Министра промышленности!",
    date: "07.03.2025",
    img: "/news/88/preview-cut.jpg",
    preParagraph: `Дорогие коллеги! Милые дамы!`,
    paragraph: `<div>
      <p><img src="/news/91/91.jpg" alt="Поздравление с 8 марта!"></p> 
    `,
  },   
  {
    id: 90,
    title: "Поздравление с 8 марта!",
    date: "07.03.2025",
    img: "/news/90/preview-cut.jpg",
    preParagraph: `Уважаемые, милые и дорогие женщины-коллеги, а также ветераны производства ОАО «Беларускабель»!`,
    paragraph: `<div>
      <p>Уважаемые, милые и дорогие женщины-коллеги, а также ветераны производства ОАО «Беларускабель»!</p>
      <p>Примите наши искренние поздравления с Днем женщин!<br>
      Этот красивый праздник в начале весны приходит к нам, когда всё расцветает и оживает. Хочется от всей души поздравить Вас с Днем женщин и пожелать самых важных и бесценных вещей: здоровья, любви и простого человеческого счастья. Пусть дома всегда царит тепло и уют, пусть близкие и родные всегда будут рядом, пусть жизнь будет полна радости.
      </p> 
      <p>Пусть этот день подарит вам прекрасное настроение, исполнение заветных желаний, добавит в вашу жизнь яркие краски и позитив, а грусть и уныние никогда не коснутся ваших сердец. Желаем вам удачи и благополучия, хорошего настроения и радости открытий, творчества и ярких достижений. Пусть окружают вас надежные друзья и заботливые мужчины! Будьте успешны, счастливы и обязательно достигайте своих целей! С праздником!</p> 
      <p>Директор В.П. ШИЛОВ<br>
      Председатель профкома Л.И. БАЛАНЧУК</p> 
      <p><img src="/news/90/90.jpg" alt="Поздравление с 8 марта!"></p> 
    `,
  },  
  {
    id: 89,
    title: "Поздравление директора с Днем защитников Отечества и Вооруженных Сил Республики Беларусь!",
    date: "21.02.2025",
    img: "/news/89/preview-cut.jpg",
    preParagraph: `Уважаемые защитники отечества!`,
    paragraph: `<div>
      <p>Уважаемые защитники отечества!</p>
      <p>23 февраля – это праздник мужества, силы духа, доблести и чести. </p> 
      <p>В этот день мы отдаем дань уважения и признательности всем воинам, на протяжении веков оберегавшим нашу родину. Мы говорим особые слова благодарности ветеранам Ветеранов Великой Отечественной войны, отстоявшим родную землю у фашистских оккупантов. Это праздник и тех, кто сегодня стоит  на страже нашей суверенности. </p> 
      <p>Сегодня защитником Отечества является каждый, кто считает своим долгом беречь родную землю, защищать её интересы, чья жизнь и работа подчинены единой цели – благополучию и процветанию нашей страны.</p> 
      <p>Желаем вам доброго здоровья и благополучия,  успехов во всех делах и начинаниях! Пусть мир и добро царят в ваших семьях!</p> 
      <p>С праздником! </p> 
      <p>С уважением, <br>
      Директор										В.П.Шилов</p> 
      <p><img src="/news/89/89.jpg" alt="с Днем защитников Отечества"></p> 
    `,
  },   
  {
    id: 88,
    title: "Поздравление Министра промышленности",
    date: "21.02.2025",
    img: "/news/88/preview-cut.jpg",
    preParagraph: ``,
    paragraph: `<div>
      <p><img src="/news/88/88.jpg" alt="Поздравление Министра промышленности"></p> 
    `,
  },    
  {
    id: 87,
    title: "Факты системной коррупции",
    date: "06.02.2025",
    img: "/news/87/preview-cut.jpg",
    preParagraph: `Швед рассказал, в каких сферах чаще всего выявляют факты системной коррупции`,
    paragraph: `<div>
      <p>Швед рассказал, в каких сферах чаще всего выявляют факты системной коррупции</p>
      <p>К уголовной ответственности за коррупционные преступления в прошлом году привлечено более 900 лиц.</p>
      <p>— Если брать по сферам, следует выделить промышленность. Там мы выявили системную коррупцию: только из числа руководителей предприятий (в том числе таких флагманов, как БЕЛАЗ, МТЗ, «Атлант»...) привлечено (к уголовной ответственности) 35 должностных лиц. Работа в этом направлении продолжается. Непосредственно Генеральной прокуратурой в прошлом году возбуждено 56 уголовных дел, — подчеркнул
      (https://www.sb.by/articles/shved-rasskazal-v-kakikh-sferakh-chashche-vsego-vyyavlyayut-fakty-sistemnoy-korruptsii.html) Генеральный прокурор.
     </p>
      <p>@sbbytoday</p>
      <p><img src="/news/87/87.jpg" alt="Факты системной коррупции"></p> 
    `,
  },    
  {
    id: 86,
    title: "Лучшие товары 2024",
    date: "06.02.2025",
    img: "/news/86/preview-cut.jpg",
    preParagraph: `ОАО «Беларускабель» стало победителем ежегодного конкурса «Лучшие товары Республики Беларусь»!`,
    paragraph: `<div>
      <p>ОАО «Беларускабель» стало победителем ежегодного конкурса «Лучшие товары Республики Беларусь»!</p>
      <p>По итогам престижного конкурса «Лучшие товары Республики Беларусь» за 2024 год ОАО «Беларускабель» стало победителем в номинации «Продукция производственно-технического назначения с продуктом «Кабель плоский лифтовой гибкий комбинированный марки КПЛГК ТУ BY 400083186.173-2023».</p>
      <p>Продукция предприятия также признана лучшей в номинациях «Новинка года» и «Стабильное качество».</p>
      <p>Надо отметить, что ОАО «Беларускабель» не первый год участвует в конкурсе «Лучшие товары Республики Беларусь», проводимом ежегодно, начиная с 2002 года, по совместной инициативе Госстандарта, областных исполнительных комитетов и Мингорисполкома. Неоднократно становилось лауреатом конкурса в разных номинациях. А, начиная с 2017 года, –  восьмой год подряд является победителем конкурса.</p>
      <p><img src="/news/86/86.jpg" alt="Лучшие товары 2024"></p> 
    `,
  },  
  {
    id: 85,
    title: "2025 год благоустройства",
    date: "10.01.2025",
    img: "/news/85/preview-cut.jpg",
    preParagraph: `Президент Республики Беларусь Александр Григорьевич Лукашенко подписал Указ №1, которым 2025 год объявлен Годом благоустройства.`,
    paragraph: `<div>
      <p>Президент Республики Беларусь Александр Григорьевич Лукашенко подписал Указ №1, которым 2025 год объявлен Годом благоустройства.</p>
      <p>Этот год дает старт пятилетке качества и предусматривает комплекс мероприятий, направленных на создание и поддержание удобной, безопасной, современной и эстетически организованной среды жизнедеятельности людей. Реализовывать эти мероприятия государство будет совместно с организациями и гражданами.</p>
      <p>В 2025 году будут приняты масштабные меры, в том числе по наведению порядка на земле, благоустройству населенных пунктов, производственных объектов, поддержанию в надлежащем состоянии территорий вдоль автомобильных и железных дорог. Состоится не менее двух республиканских субботников.</p>
      <p>Указ предусматривает активизацию волонтерского движения и реализацию гражданских инициатив, направленных на благоустройство страны.</p>
      <p>Год благоустройства призван объединить усилия государства и общества по дальнейшему улучшению качества жизни в Республике Беларусь.</p>
      <p><img src="/news/85/85.jpg" alt="2025 год благоустройства"></p> 
    `,
  },    
  {
    id: 84,
    title: "ЕДИНЫЙ ДЕНЬ ИНФОРМИРОВАНИЯ",
    date: "21.11.2024",
    img: "/news/84/preview-cut.jpg",
    preParagraph: `21 ноября в ОАО "Беларускабель" прошёл единый день информирования.`,
    paragraph: `<div>
      <p>21 ноября в ОАО "Беларускабель" прошёл единый день информирования.</p>
      <p>Были рассмотрены темы:<br>
      Выборы Президента Республики Беларусь: будущее зависит от нас.<br>
      Вакцинация от гриппа с участием главного санитарного врача Мозырского района Талецкого Сергея Евгеньевича.</p>
      <p>Основную тему для молодёжного крыла предприятия осветила первый секретарь районного комитета БРСМ Вероника Павлова.</p>      
      <p><img src="/news/84/84-1.jpg" alt="ЕДИНЫЙ ДЕНЬ ИНФОРМИРОВАНИЯ"></p>
      <p><img src="/news/84/84-2.jpg" alt="ЕДИНЫЙ ДЕНЬ ИНФОРМИРОВАНИЯ"></p>
      <p><img src="/news/84/84-3.jpg" alt="ЕДИНЫЙ ДЕНЬ ИНФОРМИРОВАНИЯ"></p>     
      <p><img src="/news/84/84-4.jpg" alt="ЕДИНЫЙ ДЕНЬ ИНФОРМИРОВАНИЯ"></p> 
    `,
  },   
  {
    id: 83,
    title: "ПРЕЗИДЕНТСКАЯ РЕСПУБЛИКА",
    date: "21.11.2024",
    img: "/news/83/preview-cut.jpg",
    preParagraph: `В рамках нового просветительского проекта заместитель директора по идеологической работе, кадрам и социальным вопросам, председатель первичной организации ОАО "Беларускабель" РОО "Белая Русь" Светлана Фещенко провела встречу с молодёжью на тему: "Президентская республика: голос молодёжи".`,
    paragraph: `<div>
      <p>В рамках нового просветительского проекта заместитель директора по идеологической работе, кадрам и социальным вопросам, председатель первичной организации ОАО "Беларускабель" РОО "Белая Русь" Светлана Фещенко провела встречу с молодёжью на тему: "Президентская республика: голос молодёжи".</p>
      <p>Были рассмотрены достижении Беларуси за 30 лет независимости в экономике, социальной сфере, культуре, образовании, здравоохранении, на международной арене.</p>
      <p>Светлана Леонидовна сделала акцент на том, как важно знать, ценить, беречь достигнутое и приложить все усилия для дальнейшего развития и движения вперёд нашей страны.</p>
      <p>Внимание молодёжи было обращено на необходимость сделать правильный выбор во время выборов Президента Республики Беларусь.</p>      
      <p><img src="/news/83/83-1.jpg" alt="ПРЕЗИДЕНТСКАЯ РЕСПУБЛИКА"></p>
      <p><img src="/news/83/83-2.jpg" alt="ПРЕЗИДЕНТСКАЯ РЕСПУБЛИКА"></p>
      <p><img src="/news/83/83-3.jpg" alt="ПРЕЗИДЕНТСКАЯ РЕСПУБЛИКА"></p>     
    `,
  },   
  {
    id: 82,
    title: "ПРОФЕССИОНАЛЬНЫЕ ЭКСКУРСИИ - ПРОФЕССИИ МОИХ РОДИТЕЛЕЙ",
    date: "20.11.2024",
    img: "/news/82/preview-cut.jpg",
    preParagraph: `20 ноября 2024 г. в рамках областного информационно-образовательного проекта "Профессиональные экскурсии - профессии моих родителей" ОАО "Беларускабель" посетили учащиеся 2-х государственных учреждений образования г. Мозыря: средней школы  № 2  и средней школы № 6.`,
    paragraph: `<div>
      <p>20 ноября 2024 г. в рамках областного информационно-образовательного проекта "Профессиональные экскурсии - профессии моих родителей" ОАО "Беларускабель" посетили учащиеся 2-х государственных учреждений образования г. Мозыря: средней школы  № 2  и средней школы № 6.</p>
      <p>Главный технолог Дмитрий Шульга провел обзорную экскурсию по предприятию, ознакомил с основными производственными процессами, продемонстрировал работу технологического оборудования и рассказал о номенклатуре выпускаемых изделий.</p>
      <p>Заместитель директора по идеологической работе, кадрам и социальным вопросам Светлана Фещенко рассказала об объектах социальной сферы, а также о том, работники каких профессий и специальностей трудятся на предприятии и где их можно приобрести.</p>      
      <p><img src="/news/82/83-1.jpg" alt="ПРОФЕССИОНАЛЬНЫЕ ЭКСКУРСИИ - ПРОФЕССИИ МОИХ РОДИТЕЛЕЙ"></p>
      <p><img src="/news/82/83-2.jpg" alt="ПРОФЕССИОНАЛЬНЫЕ ЭКСКУРСИИ - ПРОФЕССИИ МОИХ РОДИТЕЛЕЙ"></p>
    `,
  },   
  {
    id: 81,
    title: "СО ВСЕМИРНЫМ ДНЁМ КАЧЕСТВА!",
    date: "14.11.2024",
    img: "/news/81/preview-cut.jpg",
    preParagraph: `Сегодня отмечается Всемирный день качества`,
    paragraph: `<div>
      <p>Сегодня отмечается Всемирный день качества</p>
      <p>В этом году в Беларуси праздник проводится под девизом «Качество во всем – залог конкурентоспособности продукции и процветания государства».</p>
      <p>Объявление Президентом страны Александром Лукашенко нынешнего года Годом качества придало новый импульс развитию белорусского качества, повышению его узнаваемости и доверия как в республике, так и на рынках самых разных стран. В Год качества Беларусь вошла с Государственным знаком качества – соответствующий Указ Президент подписал в январе 2024 года. Этим документом утверждены изображение и описание знака.</p>
      <p>ОАО "Беларускабель" уверенно продолжает традицию выпуска высокотехнологичной качественной продукции на протяжении многих десятилетий.</p>      
      <p><img src="/news/81/81-1.jpg" alt="ДЕНЬ КАЧЕСТВА"></p>
      <p><img src="/news/81/81-2.jpg" alt="ДЕНЬ КАЧЕСТВА"></p>
      <p><img src="/news/81/81-3.jpg" alt="ДЕНЬ КАЧЕСТВА"></p>
      <p><img src="/news/81/81-4.jpg" alt="ДЕНЬ КАЧЕСТВА"></p>      
      <p><img src="/news/81/81-5.jpg" alt="ДЕНЬ КАЧЕСТВА"></p>      
    `,
  },   
  {
    id: 80,
    title: "МЕЖДУНАРОДНЫЙ ДЕНЬ ЭНЕРГОСБЕРЕЖЕНИЯ",
    date: "11.11.2024",
    img: "/news/80/preview-cut.jpg",
    preParagraph: `11 ноября- международный День энергосбережения.`,
    paragraph: `<div>
      <p>11 ноября- международный День энергосбережения.</p>
      <p>В Беларуси проходит республиканская информационно-образовательная акция "Беларусь - энергоэффективная страна".</p>
      <p>Целью проведения акции является повышение осведомленности населения о важности эффективного использования эгергоресурсов, возможных способах и методах их экономии, в том числе в повседневной жизни, что является значимой мерой в улучшении благосостояния граждан и экономического страны.</p>
      <p><img src="/news/80/80-2.jpg" alt="ДЕНЬ ЭНЕРГОСБЕРЕЖЕНИЯ"></p>
      <p><img src="/news/80/80-3.jpg" alt="ДЕНЬ ЭНЕРГОСБЕРЕЖЕНИЯ"></p>
      <p><img src="/news/80/80-4.jpg" alt="ДЕНЬ ЭНЕРГОСБЕРЕЖЕНИЯ"></p>      
    `,
  },    
  {
    id: 79,
    title: "Календарь подготовки и проведения выборов Президента Беларуси.",
    date: "11.11.2024",
    img: "/news/79/preview-cut.jpg",
    preParagraph: `Напоминаем ключевые даты.`,
    paragraph: `<div>
      <p>Напоминаем ключевые даты.</p>
      <p>Основной день голосования — 26 января 2025 года. Досрочное голосование начнется 21 января 2025 года.</p>
      <p>Сбор подписей за выдвижение в кандидаты в Президенты Беларуси продлится до 6 декабря.</p>
      <p>Национальные наблюдатели должны аккредитоваться до 20 января 2025 года.</p>      
      <p><img src="/news/79/79.jpg" alt="выбоы"></p>

    `,
  },   
  {
    id: 78,
    title: "МИНИСТР ПРОМЫШЛЕННОСТИ ПОЗДРАВИЛ РАБОТНИКОВ ОТРАСЛИ С ДНЁМ ОКТЯБРЬСКОЙ РЕВОЛЮЦИИ",
    date: "07.11.2024",
    img: "/news/78/preview-cut.jpg",
    preParagraph: `Более ста лет мы отмечаем этот день как важную дату, которая дала старт новому периоду в развитии общества. `,
    paragraph: `<div>
      <p>«Более ста лет мы отмечаем этот день как важную дату, которая дала старт новому периоду в развитии общества. События тех давних времён претворили в жизнь такие основополагающие принципы как уважение к людям труда и социальной справедливости. Сегодня наша страна не просто сохранив, но и приумножив лучшие достижения советской эпохи, уверенно идёт своим независимым путём и активно развивается. Мирный созидательный труд, социальная справедливость, уважение к прошлому выступают важными составляющими консолидации белорусского общества», - говорится в поздравлении.</p>
      <p>Министерство промышленности гордится современными достижениями предприятий отрасли, которые выступают источником прогресса и инноваций Республики Беларусь, подчеркнул Александр Ефимов.</p>
      <p>Полный текст поздравления размещен на официальном сайте (<a target="_blank" href="https://minprom.gov.by/pozdravlenie-ministra-promyshlennosti-s-dnjom-oktyabrskoj-revoljucii/">https://minprom.gov.by/pozdravlenie-ministra-promyshlennosti-s-dnjom-oktyabrskoj-revoljucii/</a>) Минпрома.</p>
      <p><img src="/news/78/78.jpg" alt="поздравление"></p>

    `,
  },   
  {
    id: 77,
    title: "УЧАСТИЕ В МИТИНГЕ, ПОСВЯЩЁННОМ ДНЮ ОКТЯБРЬСКОЙ РЕВОЛЮЦИИ",
    date: "07.11.2024",
    img: "/news/77/preview-cut.jpg",
    preParagraph: `Представители администрации, трудового коллектива, профсоюза, общественных объединений ОАО "Беларускабель" приняли участие в митинге`,
    paragraph: `<div>
      <p>Представители администрации, трудового коллектива, профсоюза, общественных объединений ОАО "Беларускабель" приняли участие в митинге, посвящённом Дню Октябрьской революции.</p>
      <p>Мы уважительно относимся к своей истории, бережно храним память о наших предках, сохраняем и приумножаем лучшие завоевания социализма.</p>
      <p>Только вместе мы будем и дальше делать нашу страну сильнее и краше!</p>
      <p><img src="/news/77/77-3.jpg" alt="митинг"></p>
      <p><img src="/news/77/77-2.jpg" alt="митинг"></p>
      <p><img src="/news/77/77-1.jpg" alt="митинг"></p>
    `,
  },      
  {
    id: 76,
    title: "ОСЕННИЙ МЕСЯЧНИК ПО УБОРКЕ ТЕРРИТОРИИ",
    date: "04.11.2024",
    img: "/news/76/preview-cut.jpg",
    preParagraph: `В рамках осеннего месячника по санитарной очистке и уборке территории работники ОАО "Беларускабель" произвели уборку`,
    paragraph: `<div>
      <p>В рамках осеннего месячника по санитарной очистке и уборке территории работники ОАО "Беларускабель" произвели уборку мусора вдоль лестницы, очистку лотка лестницы с оврага на ул. Котовского (со стороны проходной завода до детского сада № 28).</p>
      <p><img src="/news/76/76-2.jpg" alt="осенний месячник"></p>
      <p><img src="/news/76/76-1.jpg" alt="осенний месячник"></p>
    `,
  },    
  {
    id: 75,
    title: "ПРИБЫЛО НОВОЕ ОБОРУДОВАНИЕ",
    date: "02.11.2024",
    img: "/news/75/preview-cut.jpg",
    preParagraph: `В ОАО "Беларускабель" прибыло новое оборудование.`,
    paragraph: `<div>
      <p>В ОАО "Беларускабель" прибыло новое оборудование.</p>
      <p>Линия грубого волочения, сделанная в Китайской Народной Республике, обладающая увеличенной скоростью волочения, повышенной точностью и однородностью, позволит исключить дефекты, и, как следствие, улучшить качество производимой продукции.</p>
      <p>Кроме того, поставленное оборудование позволит снизить затраты на сырье и энергию.</p>
      <p><img src="/news/75/75-1.jpg" alt="новое оборудование"></p>
      <p><img src="/news/75/75-2.jpg" alt="новое оборудование"></p>
    `,
  },    
  {
    id: 74,
    title: "3-е общекомандное место по настольному теннису",
    date: "27.10.2024",
    img: "/news/74/preview-cut.jpg",
    preParagraph: `Команда ОАО "Беларускабель" приняла участие в чемпионате Мозырского района по настольному теннису среди предприятий`,
    paragraph: `<div>
      <p>Команда ОАО "Беларускабель" приняла участие в чемпионате Мозырского района по настольному теннису среди предприятий, организаций и учебных заведений.</p>
      <p>Среди предприятий первой группы ОАО "Беларускабель" заняло 3-е общекомандное место.</p>
      <p>Поздравляем наших спортсменов! Желаем новых побед!</p>
      <p><img src="/news/74/74-1.jpg" alt="настольный теннис"></p>
      <p><img src="/news/74/74-2.jpg" alt="настольный теннис"></p>
      <p><img src="/news/74/74-3.jpg" alt="настольный теннис"></p>
    `,
  },    
  {
    id: 73,
    title: "ТРЕЗВЫЙ ДВОР",
    date: "26.10.2024",
    img: "/news/73/preview-cut.jpg",
    preParagraph: `26 октября 2024 г. члены добровольной дружины ОАО "Беларускабель" в рамках профилактической акции "Трезвый двор"`,
    paragraph: `<div>
      <p>26 октября 2024 г. члены добровольной дружины ОАО "Беларускабель" в рамках профилактической акции "Трезвый двор" вышли на дежурство по охране общественного порядка.</p>
      <p>Акция направлена на профилактику правонарушений, совершаемых в общественных местах, в том числе в состоянии алкогольного опьянения.</p>
      <p><img src="/news/73/73-1.jpg" alt="ТРЕЗВЫЙ ДВОР"></p>
      <p><img src="/news/73/73-2.jpg" alt="ТРЕЗВЫЙ ДВОР"></p>
    `,
  },   
  {
    id: 72,
    title: "Утвержден план мероприятий по подготовке и проведению выборов Президента Беларуси. Даты назвали в ЦИК.",
    date: "24.10.2024",
    img: "/news/72/preview-cut.jpg",
    preParagraph: `Основной день голосования — 26 января 2025 года.`,
    paragraph: `<div>
      <p>Основной день голосования — 26 января 2025 года.</p>
      <p>Досрочное голосование начнется 21 января 2025 года.</p>
      <p>Заявки на регистрацию инициативных групп по выдвижению кандидатов в президенты надо подать не позднее 1 ноября 2024 года. Сбор подписей за выдвижение в кандидаты в Президенты Беларуси начнется 7 ноября.</p>
      <p>Национальные наблюдатели на президентских выборах должны аккредитоваться до 20 января 2025 года.</p>
      <p>Будут образованы 153 территориальные и более 5 тысяч участковых комиссий. Для них разработано методическое пособие, будут проведены тренинги.</p>
      <p><img src="/news/72/72.jpg" alt="план мероприятий"></p>
      
    `,
  },    
  {
    id: 71,
    title: "ЦИК представил логотип президентской избирательной кампании 2025 года",
    date: "24.10.2024",
    img: "/news/71/preview-cut.jpg",
    preParagraph: `Логотип представляет собой контур Государственной границы Республики Беларусь`,
    paragraph: `<div>
      <p>Логотип представляет собой контур Государственной границы Республики Беларусь с нанесенным на нем Государственным Гербом и Государственном флагом. Справа от контура на флаге расположена надпись: «Выборы Президента Республики Беларусь» и дата выборов. Все очень емко, ярко и стильно.</p>
      <p><img src="/news/71/71.jpg" alt="логотип президентской избирательной кампании"></p>
      
    `,
  },    
  {
    id: 70,
    title: "«О работе Молодёжного совета»",
    date: "23.10.2024",
    img: "/news/70/preview-cut.jpg",
    preParagraph: `Член Молодёжного совета при Гомельском областном Совете депутатов Андрей Мартинович принял участие в семинаре "О работе Молодёжного совета".`,
    paragraph: `<div>
      <p>Член Молодёжного совета при Гомельском областном Совете депутатов Андрей Мартинович принял участие в семинаре "О работе Молодёжного совета".</p>
      <p>После окончания работы семинара его участники присоединились к акции "Дай лесу новае жыццё!".</p>
      <p><img src="/news/70/70.jpg" alt="«О работе Молодёжного совета»"></p>
      
    `,
  },    
  {
    id: 69,
    title: "Дай лесу новае жыццё ",
    date: "22.10.2024",
    img: "/news/69/preview-cut.jpg",
    preParagraph: `Работники ОАО "Беларускабель" присоединились к республиканской акции "Дай лесу новае жыццё".`,
    paragraph: `<div>
      <p>Работники ОАО "Беларускабель" присоединились к республиканской акции "Дай лесу новае жыццё".</p>
      <p>Все с большим пониманием отнеслись к вопросу о необходимости лесовосстановления после июльский стихии.</p>
      <p>С энтузиазмом поддержали инициативу нашего Президента.</p>
      <p>Представители трудового коллектива, всех общественных объединений и организаций предприятия в эти октябрьские дни выполняют работы по лесовосстановлению на буреломных участках Боковского опытно-производственного лесничества в Мозырском районе. </p>
      <p><img src="/news/69/69-4.jpg" alt="Дай лесу новае жыццё "></p>
      <p><img src="/news/69/69-1.jpg" alt="Дай лесу новае жыццё "></p>       
      <p><img src="/news/69/69-2.jpg" alt="Дай лесу новае жыццё "></p>
      <p><img src="/news/69/69-3.jpg" alt="Дай лесу новае жыццё "></p>
      
    `,
  },   
  {
    id: 68,
    title: "День отца",
    date: "21.10.2024",
    img: "/news/68/preview-cut.jpg",
    preParagraph: `21 октября в Республике Беларусь отмечается День отца.`,
    paragraph: `<div>
      <p>21 октября в Республике Беларусь отмечается День отца. Новый семейный праздник установлен Указом Президента Республики № 198 от 9 июня 2022 года, с целью подчеркнуть особую значимость роли мужчин в воспитании детей, создании крепкой и счастливой семьи.</p>
      <p><img src="/news/68/68.jpg" alt="День отца"></p>       
    `,
  },   
  {
    id: 67,
    title: "«МАРАФОН ЕДИНСТВА». ВРЕМЯ ВЫБРАЛО НАС",
    date: "19.10.2024",
    img: "/news/67/preview-cut.jpg",
    preParagraph: `Представители ОАО "Беларускабель" приняли участие в общественно-культурной акции.`,
    paragraph: `<div>
      <p>Представители ОАО "Беларускабель" приняли участие в общественно-культурной акции, которая прошла в г. Гомеле по инициативе Президента Республики Беларусь Александра Григорьевича Лукашенко.</p>
      <p>Марафон ещё раз показал, что наша страна едина, что наши люди миролюбивы, трудолюбивы, толерантны. Мы бережно храним свою историю, ценим и сохраняем традиции.</p>
      <p>Марафон подарил много приятных впечатлений и позитивных эмоций нашим участникам!</p>
      <p><img src="/news/67/67-1.jpg" alt="МАРАФОН ЕДИНСТВА"></p>       
      <p><img src="/news/67/67-2.jpg" alt="МАРАФОН ЕДИНСТВА"></p>       
      <p><img src="/news/67/67-3.jpg" alt="МАРАФОН ЕДИНСТВА"></p>
      <p><img src="/news/67/67-4.jpg" alt="МАРАФОН ЕДИНСТВА"></p>
      <p><img src="/news/67/67-5.jpg" alt="МАРАФОН ЕДИНСТВА"></p> 
    `,
  },    
  {
    id: 66,
    title: "ЕДИНЫЙ ДЕНЬ ИНФОРМИРОВАНИЯ",
    date: "17.10.2024",
    img: "/news/66/preview-cut.jpg",
    preParagraph: `16 октября 2024 г. в ОАО "Беларускабель" прошёл единый день информирования.`,
    paragraph: `<div>
      <p>16 октября 2024 г. в ОАО "Беларускабель" прошёл единый день информирования.</p>
      <p>Темы дня:<br>
      1.Семейное воспитание как основа сильного государства.<br>
      2. Порядок расчёта листков нетрудоспособности.<br>
      3. Профилактика киберпреступлений.</p>
      <p><img src="/news/66/66-1.jpg" alt="ЕДИНЫЙ ДЕНЬ ИНФОРМИРОВАНИЯ"></p>       
      <p><img src="/news/66/66-2.jpg" alt="ЕДИНЫЙ ДЕНЬ ИНФОРМИРОВАНИЯ"></p>       
    `,
  },    
  {
    id: 65,
    title: "НЕДЕЛЯ РОДИТЕЛЬСКОЙ ЛЮБВИ",
    date: "14.10.2024",
    img: "/news/65/preview-cut.jpg",
    preParagraph: `14.10.2024 дан старт Неделе родительской любви. Белорусы отметили День матери. Готовимся к празднованию Дня отца 21 октября.`,
    paragraph: `<div>
      <p>14.10.2024 дан старт Неделе родительской любви. Белорусы отметили День матери. Готовимся к празднованию Дня отца 21 октября.</p>
      <p>Эти трогательные праздники вызывают в душе у каждого человека чувства нежности, добра и теплоты.</p>
      <p>В рамках Недели родительской любви представители ОАО "Беларускабель" приняли участие в праздничном мероприятии "Прекрасен мир родительской любви».</p>
      <p>Сотрудники Мозырской районной центральной библиотеки им. А.С.Пушкина подготовили яркую насыщенную программу, включающую в себя поздравления, беспроигрышную лотерею, интеллектуальный турнир "Главное слово в нашей судьбе".</p>
      <p>Волшебную атмосферу празднику добавили музыкальные номера от Детской школы искусств № 2.</p>
      <p>Сувениры и подарки для участников мероприятия подготовлены Мозырской районной организацией "Белая Русь", а розы для каждой женщины - Мозырской районной организацией ОО "Белорусский республиканский союз молодёжи" и вручили их активисты молодёжной первички ОАО "Беларускабель".</p>      
      <p><img src="/news/65/65-2.jpg" alt="НЕДЕЛЯ РОДИТЕЛЬСКОЙ ЛЮБВИ"></p> 
      <p><img src="/news/65/65-3.jpg" alt="НЕДЕЛЯ РОДИТЕЛЬСКОЙ ЛЮБВИ"></p> 
      <p><img src="/news/65/65-4.jpg" alt="НЕДЕЛЯ РОДИТЕЛЬСКОЙ ЛЮБВИ"></p> 
      <p><img src="/news/65/65-1.jpg" alt="НЕДЕЛЯ РОДИТЕЛЬСКОЙ ЛЮБВИ"></p> 
    `,
  },    
  {
    id: 64,
    title: "Поздравление от директора с Днем матери",
    date: "14.10.2024",
    img: "/news/64/preview-cut.jpg",
    preParagraph: `Дорогие женщины-матери!`,
    paragraph: `<div>
      <p>От всей души с большой теплотой и сердечностью поздравляю вас с Днем матери и с праздником Покрова Пресвятой Богородицы!</p>
      <p>Эти два праздника олицетворяют силу любви и заботы.</p>      
      <p>Сегодня мы говорим спасибо главному человеку в нашей жизни - матери и просим заступничества Царицы Небесной.</p>      
      <p>От души желаю вам неугасаемой доброты сердца, неувядаемой любви и счастья в жизни, неизменной благодати за окном и в душе.</p>      
      <p>Пусть Пресвятая Богородица хранит вас и ваши семьи, пусть небо всегда будет мирным!</p>
      <p>Будьте всегда здоровы и любимы своими детьми!<br>
      Низкий вам поклон за любовь и терпение, за каждодневный труд и ласку!</p>      
      <p>С уважением,<br>
      Директор ОАО "Беларускабель"<br>
      В.П.Шилов</p>      
    `,
  },   
  {
    id: 63,
    title: "С ДНЁМ СТАНДАРТИЗАЦИИ",
    date: "14.10.2024",
    img: "/news/63/preview-cut.jpg",
    preParagraph: `Сегодня в нашей стране отмечается День стандартизации.`,
    paragraph: `<div>
      <p>Сегодня в нашей стране отмечается День стандартизации.</p>
      <p>Поздравляем всех причастных к этому празднику!</p>
      <p>В ОАО "Беларускабель" это работники отдела технического контроля.</p>
      <p>Примите искренние пожелания крепкого здоровья, благополучия и процветания, оптимизма и вдохновения, светлых идей и талантливых решений! Пусть точность во всем будет залогом успеха и залогом достижения новых вершин, а вы будете эталоном счастья и успешности!</p>
      <p><img src="/news/63/63.jpg" alt="С ДНЁМ СТАНДАРТИЗАЦИИ"></p>      
    `,
  },    
  {
    id: 62,
    title: "Поздравление Министра промышленности Александра Ефимова по случаю республиканской Недели родительской любви",
    date: "14.10.2024",
    img: "/news/62/preview-cut.jpg",
    preParagraph: `Уважаемые коллеги, дорогие друзья!`,
    paragraph: `<div>
      <p><img src="/news/62/61.jpg" alt="Поздравление министра"></p>
      <p>Уважаемые коллеги, дорогие друзья!</p>
      <p>В Беларуси 14 октября стартует республиканская Неделя родительской любви, во время которой мы все с особым волнением отметим День матери и День отца.</p>
      <p>Эти трогательные праздники пробуждают в сердце каждого человека чувства тепла и доброты, напоминая о тех, кто подарил самое ценное на земле, – жизнь.</p>
      <p>Независимо от возраста, мы все нуждаемся в добрых словах матери и мудром совете отца. И где бы мы ни находились, кем бы мы ни были – родительская любовь всегда оберегает и укрепляет каждого из нас.</p>
      <p>Фундамент нашего государства начинается с крепкой семьи, в которой детям, наряду с почитанием семейных ценностей, прививают чувство патриотизма и беззаветной любви к Родине. Слова особой благодарности адресую трудовым династиям за бесценное наследие, бережно сохранённое и переданное сегодняшнему поколению. Спасибо вам огромное за воспитание верных дочерей и сыновей.</p>
      <p>Дорогие коллеги – матери, отцы! Ваши надежная поддержка, безмерное терпение и щедрость души заслуживают самых высоких похвал.</p>
      <p>Искренне желаю вам безграничного семейного счастья! Пусть каждый день согревает любовью и заботой дорогих и близких вам людей!</p>
      <p>Крепкого здоровья, долгих и благополучных лет жизни! </p>
      <p>С уважением,<br>
      Министр промышленности<br>
      Республики Беларусь						А.В.Ефимов</p>
    `,
  },   
  {
    id: 61,
    title: "УЧАСТИЕ В ОСЕННЕМ ЛЕГКОАТЛЕТИЧЕСКОМ КРОССЕ",
    date: "12.10.2024",
    img: "/news/61/preview-cut.jpg",
    preParagraph: `Представители ОАО "Беларускабель" приняли участие в осеннем легкоатлетическом кроссе, который прошёл 12 октября в лесопарке "Молодёжный".`,
    paragraph: `<div>      
      <p>Представители ОАО "Беларускабель" приняли участие в осеннем легкоатлетическом кроссе, который прошёл 12 октября в лесопарке "Молодёжный".</p>
      <p>Наши спортсмены достойно выступили. Пробежавшись на свежем воздухе, зарядились энергией, позитивом. </p>
      <p>Кудрявцева Елена показала хороший результат, в своей возрастной категории завоевав второе место. </p>
      <p>Поздравляем!!! Приглашаем наших работников ещё более активно включаться к занятиям физкультурой и спортом.</p>
      <p><img src="/news/61/61.jpg" alt="УЧАСТИЕ В ОСЕННЕМ ЛЕГКОАТЛЕТИЧЕСКОМ КРОССЕ"></p>      
    `,
  }, 
  {
    id: 60,
    title: "Поздравление Министра промышленности Республики Беларусь с 30-летием со дня образования Министерства промышленности Республики Беларусь и профессиональным праздником - Днем машиностроителя",
    date: "27.09.2024",
    img: "/news/60/preview-cut.jpg",
    preParagraph: ``,
    paragraph: `<div>
      <p><img src="/news/60/news-60.jpg" alt="Поздравление министра"></p>
    `,
  },  
  {
    id: 59,
    title: "Поздравление директора с Днем Независимости Республики Беларусь и 80-й годовщиной освобождения Беларуси от немецко-фашистских захватчиков",
    date: "27.06.2024",
    img: "/news/53/preview-cut.jpg",
    preParagraph: ``,
    paragraph: `<div>
      <p><img src="/news/59/14.png" alt="80"></p>
      <p>Уважаемые работники и пенсионеры, ветераны Великой Отечественной войны, партнеры и жители Мозырского района!</p>
      <p>Примите искренние поздравления с главным государственным праздником – Днём Независимости Республики Беларусь и 80-ой годовщиной со дня освобождения Беларуси от немецко-фашистских захватчиков!<br>
      День Независимости – это важнейшая дата в истории становления белорусского государства. Это символ суверенитета и свободы нашей Родины, героического прошлого и достойного будущего белорусского народа.<br>
      В этот по-настоящему святой для каждого белоруса праздник мы чтим героизм и мужество защитников Отечества, высоко ценим самоотверженность тружеников тыла и всех, кто в послевоенные годы поднимал из руин разрушенные города и сёла, восстанавливал народное хозяйство, создавал национальное богатство, кто и сегодня вносит достойный вклад в социально-экономическое развитие Беларуси.<br>
      Наша страна является островком безопасности и миролюбия, общим домом для людей разных национальностей.<br>
      Пусть и в дальнейшем наша сплочённость, сохранение лучших традиций станут основой укрепления национального единства и независимости Республики Беларусь.<br>
      В этот праздничный день желаю всем жителям нашей Мозырщины здоровья, счастья, благополучия, успешного труда во имя жизни будущих поколений. Пусть всегда в ваших семьях будут мир и согласие, царят тепло, любовь и взаимопонимание!<br>

    <p>С уважением, Виталий Петрович  Шилов – директор ОАО «Беларускабель».</p>

    `,
  },   
  {
    id: 57,
    title: "МЧС напоминает «Неосторожное обращение с огнём - основная причина пожаров»",
    date: "20.06.2024",
    img: "/news/57/Buklet.jpg",
    preParagraph: ``,
    paragraph: `<div>
      <p><img src="/news/57/Buklet.jpg" alt="МЧС"></p>
      <div class="fluid-width-video-wrapper" style="padding-top: 56.25%;"><iframe src="https://www.youtube.com/embed/videoseries?list=PL6UfMc07JDjYr5FeX8n5jxGwgGX1V4TbD" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" name="fitvid0"></iframe></div>
    `,
  }, 
  {
    id: 58,
    title: "Беларусь против табака",
    date: "17.06.2024",
    img: "/news/58/antitabachnaya-aktsiya.jpg",
    preParagraph: ``,
    paragraph: `<div>
      <p><img src="/news/58/antitabachnaya-aktsiya.jpg" alt="Антитабак"></p>
      <p>В целях реализации положений Рамочной конвенции ВОЗ по борьбе против табака, государственной программы «Здоровье народа и демографическая безопасность» на 2021-2025 годы, профилактики заболеваний, причинно связанных с табакокурением, в Республике Беларусь 2 раза в год проводится республиканская информационно-образовательная антитабачная акция, приуроченная к "Единым дням здоровья": 31 мая – «Всемирный день без табака», а также 16 ноября – Единый день здоровья «Всемирный день некурения. Профилактика онкологических заболеваний».</p>
      <p>Антитабачные акции Республики Беларусь направлены на информирование населения о пагубных последствиях для здоровья потребления табака и воздействия табачного дыма, формирование у гражданского общества устойчивых мер, направленных на борьбу с потреблением табака. Профилактика табакокурения в нашей стране осуществляется:<br>  
      – с привлечением представителей организаций здравоохранения, учреждений образования, культуры, спорта и туризма, правоохранительных органов, общественных организаций;<br>      
      – путем проведения дней открытой информации;<br>      
      – путем консультирования населения в учреждениях здравоохранения, образования и на предприятиях, органами СМИ.</p      
      <p>Осуществление жёсткой борьбы против табака влияет на общественное мнение. Мониторинг проблемы курения имеет решающее значение для информирования населения. Ключевым императивом является защита детей от негативного воздействия пассивного курения. Осуществляется денормализация употребления табака за счёт повышения его социальной неприемлимости. Меры, предпринятые в рамках борьбы против курения, Республикой Беларусь:<br>  
      – требования к упаковке табачных и никотинсодержащих изделий;<br>      
      – запрет рекламы и спонсорства табачными производителями массовых развлекательных мероприятий;<br>
      – ограничение продажи, в том числе через торговые автоматы, а также публичной демонстрации табачных изделий;<br>
      – создание свободных от табачного дыма площадок на открытом воздухе (школьные территории, спортивные стадионы, парки, пляжи);<br>      
      – просвещение семей о возможностях уменьшения загрязнения воздуха внутри помещений, связанного с курением, которое подвергает детей риску;<br>      
      – защита политики общественного здравоохранения от коммерческих и других интересов табачной промышленности;<br>      
      – принятие ценовых и налоговых мер по сокращению спроса на табак;<br>      
      – регулирование состава табачных изделий;<br>      
      – оказание помощи людям в предупреждении их привыкания к табаку;<br>
      – контроль незаконной торговли табачными изделиями;<br>      
      – запрет на продажу табачных изделий несовершеннолетним.</p>
      <p>Перечисленные меры дают свои результаты, и в последние годы наблюдается устойчивая динамика снижения потребления табака. Однако очень многое зависит от каждого конкретного человека, его стремлении к здоровью и отказу от вредных привычек, в том числе – потребления табачных и никотинсодержащих изделий. </p>
    `,
  },    
  {
    id: 56,
    title: "9 Мая 2024 поздравление директора",
    date: "06.05.2024",
    img: "/news/56/9-may.jpg",
    preParagraph: `Уважаемые ветераны Великой Отечественной войны!`,
    paragraph: `<div>
      <p>
      Уважаемые ветераны Великой Отечественной войны!
      </p>
      <p>
      Дорогие белорусы!
      </p>    
      <p>
      9 Мая – это священный день в нашей истории, день доблести и мужества нашего народа, который неимоверными усилиями отстоял свободу своей Родины. 79 лет минуло с той поры, когда было повержено самое страшное зло на планете – фашизм. В эти дни мы снова и снова с глубокой признательностью обращаемся к ветеранам и участникам войны, ко всем, кто в сороковые боевые годы своими героическими ратными и трудовыми подвигами приближал Великую Победу.
      </p>
      <p>
      Дорогие ветераны! Вы достойно прошли страшными фронтовыми дорогами, выстояли у станков и на полях.  Вы победили. Ваши личные мужество и героизм, проявленные за свободу нашей родины, были и остаются лучшим примером для всех поколений потомков. 
      </p>
      <p>
      Сердечно поздравляем вас с 79-й годовщиной Победы в Великой Отечественной войне, низко кланяемся перед теми, кто подарил нам радость жизни на свободной земле. Спасибо вам за вашу отвагу и стойкость, верность воинскому долгу и мужество, за веру в наше Отечество! От всей души желаем доброго здоровья, мира, благополучия и счастья. Пусть обойдут вас стороной печали и невзгоды, отпустят болезни, а тепло наших сердец согреет вашу жизнь!
      </p>
      <p>
      <span style="display: block">Директор</span>
      <span style="display: block">В.П.Шилов</span> 
      </p>
    `,
  },  
  {
    id: 55,
    title: "Поздравление директора с Праздником  труда",
    date: "30.04.2024",
    img: "/news/53/preview-cut.jpg",
    preParagraph: `Поздравление директора с Праздником  труда`,
    paragraph: `<div>
      <p>
      Сегодня я хочу искренне поздравить всех трудящихся с Праздником труда!
      </p>
      <p>
      Желаю вам здоровья, мира, бодрого настроения, успехов, открытий, идей, достижений, прорывов, новых возможностей и интересов. 
      </p>
      <p>
      Пусть каждый день вдохновляет на новые смелые свершения, ваши рабочие дни будут творческими и плодотворными, результаты труда приносят удовлетворение, радость и материальный достаток.
      </p>
    `,
  },
  {
    id: 54,
    title: "Поздравление Министерства промышленности с Днем женщин",
    date: "08.03.2024",
    img: "/news/54/preview-cut.jpg",
    preParagraph: `Поздравление Министерства промышленности с Днем женщин`,
    paragraph: `<div>
      <p>
      Уважаемые наши, милые женщины!
      </p>
      <p>
      От имени всех мужчин Министерства промышленности с огромной радостью поздравляю вас с замечательным праздником – Днем женщин!
      </p>
      <p>
      Этот праздник – самый нежный, самый обаятельный – наполняет мужские сердца особой признательностью и теплотой к нашим матерям, бабушкам, женам, дочерям, и, конечно же, коллегам.
      </p>
      <p>
      8 марта, даже в пасмурную погоду, всегда ярко и солнечно светятся ваши улыбки и наши мужские сердца, потому что день наполнен искренней радостью, светлыми чувствами, цветами и подарками.
      </p>
      <p>
      Благодарю всех вас за душевную щедрость и великую вдохновляющую силу, инициативность и неравнодушие, благодаря которым вы храните в домах мир и уют, а также создаете комфорт и благополучие на работе. И мы, мужчины, гордимся вашими профессиональными достижениями и впечатляющими успехами.
      </p>
      <p>
      Всем женщинам предприятий системы Министерства промышленности хочу пожелать оставаться такими же уверенными, красивыми и любимыми как наша родная Республика Беларусь.
      </p>
      <p>
      Семейного благополучия, цветущего весеннего настроения и приятных запоминающихся сюрпризов.
      </p>
      <p>
      Будьте счастливы и любимы сегодня, завтра и всегда!
      </p>
      <p>
      С Весной, с 8 Марта!
      </p>
      <p>
      <span style="display: block">С чувством глубокого уважения,</span>
      <span style="display: block">Министр промышленности</span> 
      <span style="display: block">Республики Беларусь</span>
      <span style="display: block">А.Н. Рогожник</span>
      </p>
    `,
  },
  {
    id: 53,
    title:
      "Поздравление директора ОАО «Беларускабель» Шилова Виталия Петровича с Днем женщин",
    date: "08.03.2024",
    img: "/news/53/preview-cut.jpg",
    preParagraph: `Поздравление директора ОАО «Беларускабель» Шилова Виталия Петровича с Днем женщин`,
    paragraph: `<div>
      <p style="text-align: center">Дорогие женщины, коллеги и заслуженные ветераны!
      <span style="display: block">Поздравляю вас с Днём женщин!</span>
      </p>
      
      <p style="text-indent: 2em;">
      Вы несете на своих хрупких плечах бремя забот о семье, окружая вниманием своих родных и близких, храня тепло домашнего очага, воспитывая детей. Вдохновляете нас, мужчин, на благородные поступки и свершения и достигаете невероятных высот в любой сфере.
      </p>
      <p style="text-indent: 2em;">
      Спасибо вам за ваш особенный интеллект, выдающийся профессионализм, исполнительность, собранность и аккуратность.
      </p>
      <p style="text-indent: 2em;">
      Пусть в ваших семьях всегда царит атмосфера весны – улыбки, отличное настроение, гармония в отношениях. Будьте здоровы, счастливы и любимы.
      </p>
      <p>
      С праздником, милые женщины!
      </p>
      <span style="display:flex; margin: 0 auto; max-width: 800px; width: 100%" ><img src="/news/53/preview.jpg" style="margin:auto"></span>
    `,
  },
  {
    id: 52,
    title: "15 февраля – День памяти воинов-интернационалистов",
    date: "15.02.2024",
    img: "/news/52/preview.jpg",
    preParagraph: `15 февраля в Республике Беларуси отмечается памятная дата – День памяти воинов-интернационалистов.`,
    paragraph: `<div>
      <p >15 февраля в Республике Беларуси отмечается памятная дата – День памяти воинов-интернационалистов.
      </p>
      <p>35 лет назад закончилась афганская война, ушла в прошлое и стала частью истории нашей страны. Это день памяти погибших на той необъявленной войне, а также глубочайшей признательности и благодарности всем вернувшимся домой, кто честно и мужественно выполнил свой воинский и гражданский долг.
      </p>
      <p>Много горя и страданий принесли нашему народу эти девять лет и пятьдесят один день тяжелых сражений в чужом краю. Но и там, в далеком Афганистане, наши земляки проявляли лучшие человеческие качества. В неимоверно трудных условиях боевой жизни, вдали от дома, ежечасно подвергаясь опасности, они сохранили верность военной присяге, воинскому и человеческому долгу.
      </p>
      <p>Именно этот день стал Днем памяти не только для тех, кто воевал в Афганистане, но и для всех воинов-интернационалистов, участвовавших в урегулировании военных конфликтов на территории ближнего и дальнего зарубежья.
      </p>
      <p>Сегодня мы отдаем дань глубокого уважения солдатам и офицерам, сержантам и генералам, врачам и гражданским советникам. Всем, кто проявил стойкость и мужество и с честью выполнил поставленные командованием задачи. Наши доблестные и мужественные воины выполнили приказ. Они прошли через трудные, страшные испытания. Очень много солдат погибло на полях сражений.
      </p>
      <p>От всей души поздравляем ветеранов боевых действий с днем вывода советских войск из Афганистана! Желаем воинам-интернационалистам, ветеранам всех войн и вооруженных конфликтов, их родным и близким счастья, удачи, здоровья и благополучия.
      </p>
      <p>В ОАО «Беларускабель» стало доброй традицией чествовать воинов-интернационалистов. Ежегодно накануне этого дня администрация и профсоюзный комитет выплачивает участникам боевых действий единовременное денежное вознаграждение. И этот год не стал исключением. Сегодня в организации трудятся трое ветеранов Афганистана. Это - Жильский Александр Владимирович, укладчик-упаковщик производственного цеха, Пограновский Пётр Дмитриевич, электромонтёр по ремонту и обслуживанию электрооборудования производственного цеха.
      </p>
      <p>Огромное спасибо, и низкий вам поклон, воины-интернационалисты, за ваш боевой подвиг, мужество и отвагу!
      </p>
      <p style="display:flex" ><img src="/news/52/preview.jpg" style="margin:auto"></p>
    `,
  },
  {
    id: 51,
    title: "Лучшие товары Республики Беларусь",
    date: "25.01.2024",
    img: "/news/51/preview.png",
    isDefault: true,
    preParagraph: `ОАО «Беларускабель»  стал лауреатом конкурса «Лучшие товары Республики Беларусь» в номинации «Продукция производственно-технического назначения», а также дипломантом категории «Стабильное качество».`,
    paragraph: `<div>
      <p>В соответствии с постановлением Государственного комитета по стандартизации Республик  Беларусь от 29 декабря 2023 г. № 99 «Об утверждении результатов конкурса «Лучшие товары Республики Беларусь» 2023 г. кабель для сигнализации и блокирования, гибкий СБМВ производства открытого акционерного общества «Беларускабель»  стал лауреатом конкурса «Лучшие товары Республики Беларусь» в номинации «Продукция производственно-технического назначения», а также дипломантом категории «Стабильное качество».
      </p>
      <p>Надо отметить, что ОАО «Беларускабель» не первый раз участвует в конкурсе «Лучшие товары Республики Беларусь», проводимом ежегодно, начиная с 2003 года, по совместной инициативе Госстандарта, областных исполнительных комитетов и Мингорисполкома. Неоднократно становилось лауреатом конкурса в разных номинациях.
      </p>
      <p style="display:flex" ><img src="/news/51/preview.png" style="width:500px;margin:auto"></p>
    `,
  },
  {
    id: 50,
    title: "Благодарность БРСМ",
    date: "24.01.2024",
    img: "/news/50/preview_rotate.jpg",
    preParagraph: `24 января 2024 г. на VI Пленуме Мозырского районного комитета Общественного объединения «Белорусский республиканский союз молодёжи» объявлена Благодарность первичной организации ОО «БРСМ» ОАО «Беларускабель».`,
    paragraph: `<div>
      <p>24 января 2024 г. на VI Пленуме Мозырского районного комитета Общественного объединения «Белорусский республиканский союз молодёжи» объявлена Благодарность первичной организации ОО «БРСМ» ОАО «Беларускабель».
      </p>
      <p style="display:flex" ><img src="/news/50/preview_rotate.jpg" style="margin:auto"></p>
    `,
  },
  {
    id: 49,
    title: "Год качества",
    date: "15.01.2024",
    img: "/news/49/preview.jpg",
    preParagraph: `Глава государства Александр Лукашенко подписал Указ № 375 "Об объявлении 2024 года Годом качества. В рамках Года качества будет сделан акцент на повышении конкурентоспособности Беларуси через бережное и продуманное отношение к ресурсам, реализацию высокотехнологичных и энергоемких проектов, приоритет качественных показателей над количественными.`,
    paragraph: `<div>
      <p >Глава государства Александр Лукашенко подписал Указ № 375 "Об объявлении 2024 года Годом качества".
      </p>
      <p>Данное решение принято в целях дальнейшего повышения качества жизни белорусского народа, обеспечения конкурентоспособности национальной экономики на мировой арене, стимулирования инициативы, формирования в обществе ответственности за результаты своего труда и чувства сопричастности к будущему страны.
      </p>
      <p>В рамках Года качества будет сделан акцент на повышении конкурентоспособности Беларуси через бережное и продуманное отношение к ресурсам, реализацию высокотехнологичных и энергоемких проектов, приоритет качественных показателей над количественными. Усилия будут сосредоточены на обеспечении качественных показателей путем стимулирования инициативы, внедрения рационализаторских идей, укрепления в обществе социального оптимизма, стремления созидать на общее благо. Приоритетное внимание планируется уделить формированию у граждан личной ответственности за достижение высокого качества жизни (достаточный уровень дохода, своевременная диспансеризация, здоровое питание, хорошее образование, культурный досуг).
      </p>
      <div style="display:flex; flex-flow:row wrap; gap:24px;">
        <img src="/news/49/preview.jpg" style="width:550px; margin:auto">
        <img src="/news/49/1.png" style="width:550px; margin:auto">
      </div>

    `,
  },
  {
    id: 48,
    title: "Участие в международном форуме-выставке «Российский промышленник»",
    date: "28.11.2023",
    img: "/news/48/preview.jpg",
    preParagraph: `Директор ОАО «Беларускабель» Шилов Виталий Петрович, а также представители отдела продаж приняли участие в 27-м международном форуме-выставке «Российский промышленник», который прошел с 28.11.2023 по 30.11.2023 в г. Санкт-Петербург.`,
    paragraph: `<div>
      <p >Директор ОАО «Беларускабель» Шилов Виталий Петрович, а также представители отдела продаж приняли участие в 27-м международном форуме-выставке «Российский промышленник», который прошел с 28.11.2023 по 30.11.2023 в г. Санкт-Петербург.
      </p>
      <p>Форум «Российский промышленник» – это масштабное конгрессно-выставочное мероприятие для демонстрации инновационного промышленного оборудования, продукции, технологий компаний с целью их продвижения на региональные и международные рынки.
      </p>
    <p style="display:flex" ><img src="/news/48/1.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/48/2.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/48/3.jpg" style="margin:auto"></p>
    `,
  },
  {
    id: 47,
    title: "Тренировка по гражданской обороне",
    date: "16.11.2023",
    img: "/news/47/preview.jpg",
    preParagraph: `16 ноября 2023 года в ОАО «Беларускабель» прошла тренировка по гражданской обороне на тему: «Организация выполнения мероприятий гражданской обороны при возникновении чрезвычайных ситуаций (возгорание помещения на третьем этаже заводоуправления)».`,
    paragraph: `<div>
      <p >16 ноября 2023 года в ОАО «Беларускабель» прошла тренировка по гражданской обороне на тему: «Организация выполнения мероприятий гражданской обороны при возникновении чрезвычайных ситуаций (возгорание помещения на третьем этаже заводоуправления)».
      </p>
      <p>На учебную тренировку был привлечен руководящий состав, штаб и службы гражданской обороны, эвакокомиссия, формирования гражданской обороны предприятия.</p>
    <p style="display:flex" ><img src="/news/47/1.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/47/2.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/47/3.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/47/4.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/47/preview.jpg" style="margin:auto"></p>
    `,
  },
  {
    id: 46,
    title: "Всемирный день некурения",
    date: "13.11.2023",
    img: "/news/46/1.png",
    preParagraph: `В период с 13 ноября по 19 ноября 2023 г. в Республике Беларусь проводится республиканская информационно-образовательная акция по профилактике табакокурения, как фактора риска развития онкологических заболеваний.`,
    paragraph: `<div>
      <p >В целях реализации положений Рамочной конвенции ВОЗ по борьбе против табака, государственной программы «Здоровье народа и демографическая безопасность» на 2021-2025 годы, профилактики заболеваний, причинно-связанных с табакокурением, а также в связи с проведением 16 ноября 2023 г. Единого дня здоровья «всемирный день некурения» в период с 13 ноября по 19 ноября 2023 г. в Республике Беларусь проводится республиканская информационно-образовательная акция по профилактике табакокурения, как фактора риска развития онкологических заболеваний.
      </p>
    <p style="display:flex" ><img src="/news/46/1.png" style="margin:auto"></p>
    `,
  },
  {
    id: 45,
    title: "Легкоатлетический забег",
    date: "14.10.2023",
    img: "/news/45/preview.jpg",
    preParagraph: `14 октября 2023 года работники ОАО «Беларускабель» приняли участие в осеннем легкоатлетическом забеге.`,
    paragraph: `<div>
      <p >14 октября 2023 года работники ОАО «Беларускабель» приняли участие в осеннем легкоатлетическом забеге.
      </p>
    <p style="display:flex" ><img src="/news/45/preview.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/45/1.jpg" style="margin:auto"></p>
    `,
  },
  {
    id: 44,
    title: "День матери",
    date: "13.10.2023",
    img: "/news/44/preview.jpg",
    preParagraph: `13 октября 2023 года работница  ОАО «Беларускабель» Данекина Елена Александровна приняла участие в районном торжественном мероприятии, посвященном Дню матери, которое прошло в Мозырском драматическом театре имени И.Шамякина.`,
    paragraph: `<div>
      <p >13 октября 2023 года работница ОАО «Беларускабель» Данекина Елена Александровна приняла участие в районном торжественном мероприятии, посвященном Дню матери, которое прошло в Мозырском драматическом театре имени И.Шамякина.
      </p>
      <p >Елена Александровна – ответственный работник и многодетная мама.
      </p>
      <p >Теплые слова поздравлений, музыкальные и материальные подарки получила заботливая мама накануне праздника.
      </p>
      <p style="display:flex" ><img src="/news/44/1.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/44/preview.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/44/2.jpg" style="margin:auto"></p>
    `,
  },
  {
    id: 43,
    title: "Чемпионат по мини-футболу",
    date: "11.10.2023",
    img: "/news/43/3.jpg",
    preParagraph: `11 и 12 октября 2023 года состоялся чемпионат ОАО «Беларускабель» по мини-футболу.`,
    paragraph: `<div>
      <p >11 и 12 октября 2023 года состоялся чемпионат ОАО «Беларускабель» по мини-футболу.
      </p>
      <p >Места распределились следующим образом:
      </p>
      <p >1-е место – команда заводоуправления,
      </p>
      <p >2-е место – команда производственного цеха,
      </p>
      <p >3-е место – команда ремонтно-строительного участка.
      </p>
      <p >Победители и призеры награждены дипломами и денежными призами.
      </p>
      <p >Поздравляем и желаем новых побед!
      </p>
    <p style="display:flex" ><img src="/news/43/preview.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/43/1.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/43/2.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/43/3.jpg" style="margin:auto"></p>
    `,
  },
  {
    id: 42,
    title: "Чемпионат по боулингу",
    date: "02.10.2023",
    img: "/news/42/preview.jpg",
    preParagraph: `2 октября 2023 года состоялся чемпионат ОАО «Беларускабель» по боулингу.`,
    paragraph: `<div>
      <p >2 октября 2023 года состоялся чемпионат ОАО «Беларускабель» по боулингу.
      </p>
      <p >Мероприятие, приуроченное ко Дню народного единства и Дню машиностроителя, прошедшее под названием «Сила в спорте – сила в единстве», в рамках Года мира и созидания собрало 27 команд из числа работников предприятия.
      </p>
      <p >Призовые места распределились следующим образом:
      </p>
      <p >1-е место заняла команда «Властелины кеглей»,
      </p>
      <p >2-е место – команда «Экипаж»,
      </p>
      <p >3-е место – команда «Чукарички».
      </p>
      <p >В личном зачете стали сильнейшими:
      </p>
      <p >Cреди мужчин: Зелимов Эмиль, Бездорогов Николай, Карась Олег.
      </p>
      <p >Среди женщин: Гатаулина Галина, Сидоренко Ирина, Соловей Галина.
      </p>
    <p style="display:flex" ><img src="/news/42/preview.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/42/1.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/42/2.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/42/3.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/42/4.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/42/5.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/42/6.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/42/7.jpg" style="margin:auto"></p>
    `,
  },
  {
    id: 41,
    title: "День пожилых людей",
    date: "29.09.2023",
    img: "/news/41/1.jpg",
    preParagraph: `29 сентября 2023 года ветеран труда ОАО «Беларускабель» Бондарева Надежда Николаевна приняла участие в районном торжественном мероприятии, прошедшем в Мозырском драматическом театре им. И.Мележа.`,
    paragraph: `<div>
      <p >29 сентября 2023 года ветеран труда ОАО «Беларускабель» Бондарева Надежда Николаевна приняла участие в районном торжественном мероприятии, прошедшем в Мозырском драматическом театре им. И.Мележа.
      </p>
      <p >Бондарева Надежда Николаевна проработала на предприятии более 40 лет мастером, начальником отдела технического контроля, зарекомендовала себя ответственным работником, энергичным руководителем.
      </p>
      <p >Желаем Надежде Николаевне и всем пенсионерам, ветеранам труда крепкого здоровья, долголетия, мира, любви и заботы близких.
      </p>
    <p style="display:flex" ><img src="/news/41/1.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/41/2.jpg" style="margin:auto"></p>
    <p style="display:flex" ><img src="/news/41/preview.jpg" style="margin:auto"></p>
    `,
  },
  {
    id: 40,
    title: "Поздравление директора с Днем народного единства",
    date: "15.09.2023",
    img: "/news/40/1.jpg",
    preParagraph: ``,
    paragraph: `<div>
      <p >Уважаемые работники и пенсионеры , партнеры и жители Мозырского района!
      </p>
      <p >Сердечно поздравляю вас с Днем народного единства, днём нерушимой дружбы и доверия, взаимопомощи и гражданской гордости!
      </p>
      <p >Только при условии патриотизма и сплоченности наша страна будет сильной!</p>
      <p >Желаю вам мирного благоденствия и сосуществования на родной, щедрой в любви и работе земле! Пусть наш талантливый, трудолюбивый народ ждёт великое будущее, новые уверенные победы, а наша Беларусь будет независимым, суверенным государством!
      </p>
      <p>С уважением,</p>
      <p style="display: flex; gap: 100px">
        <span>
          Директор
        </span>
        <span>
          В.П. Шилов
        </span> 
      </p>
    </div>
    <p style="display:flex" ><img src="/news/40/1.jpg" style="margin:auto;"></p>
    `,
  },
  {
    id: 39,
    title: "82 Общее собрание Ассоциации «Электрокабель»",
    date: "14.09.2023",
    img: "/news/39/preview.jpg",
    preParagraph: `Руководители ОАО «Беларускабель» в лице директора Шилова Виталия Петровича и заместителя директора по развитию Фиранчука Дмитрия Николаевича приняли участие в 82-ом Общем собрании Ассоциации «Электрокабель», которое прошло с 11 по 14 сентября 2023 г. в г. Санкт-Петербург.`,
    paragraph: `<p>Руководители ОАО «Беларускабель» в лице директора Шилова Виталия Петровича и заместителя директора по развитию Фиранчука Дмитрия Николаевича приняли участие в 82-ом Общем собрании Ассоциации «Электрокабель», которое прошло с 11 по 14 сентября 2023 г. в г. Санкт-Петербург.
    </p>
    <p style="display:flex" ><img src="/news/39/1.jpg" style="margin:auto"></p>
    `,
  },
  {
    id: 38,
    title: "Дорога Добра: Помощь на колесах!",
    date: "08.09.2023",
    img: "/news/38/preview.jpg",
    preParagraph: `8 сентября 2023 г. активисты БРСМ ОАО «Беларускабель» в рамках проведения Республиканской благотворительной акции «Дорога Добра: Помощь на колесах!» доставили гуманитарную помощь в Мозырскую районную организацию Красного Креста.`,
    paragraph: `<p>8 сентября 2023 г. активисты БРСМ ОАО «Беларускабель» в рамках проведения Республиканской благотворительной акции «Дорога Добра: Помощь на колесах!» доставили гуманитарную помощь в Мозырскую районную организацию Красного Креста.
    В рамках молодёжного проекта «Автопоезд#Беларусь. Молодежь. Созидание» эта помощь будет доставлена в учреждения: «Дом-интернат для престарелых и инвалидов «Васильевка» и Гомельский дом-интернат для детей-инвалидов с особенностями психофизического развития.  
    </p>
    <p style="display:flex" ><img src="/news/38/1.jpg" style="margin:auto"></p>
    <p style="display:flex"><img src="/news/38/2.jpg" style="margin:auto"></p>
    `,
  },
  {
    id: 37,
    title: "«НЕФТЕГАЗ-2023»",
    date: "24.04.2023",
    img: "/news/37/1.jpg",
    preParagraph: `Руководители ОАО «Беларускабель» приняли участие в 22-й международной выставке оборудования для нефтяной и газовой промышленности «НЕФТЕГАЗ-2023», которая прошла с 24 по 27 апреля 2023 года в г. Москва в ЦВК «Экспоцентр».
  `,
    paragraph: `<p>Руководители ОАО «Беларускабель» приняли участие в 22-й международной выставке оборудования для нефтяной и газовой промышленности «НЕФТЕГАЗ-2023», которая прошла с 24 по 27 апреля 2023 года в г. Москва в ЦВК «Экспоцентр».
    «Нефтегаз» в «Экспоцентре» – главная выставка нефтегазовой отрасли с 1978 года!
   Выставку «Нефтегаз» организует АО «Экспоцентр» при поддержке Министерства энергетики РФ, Министерства промышленности и торговли РФ, под патронатом Торгово-промышленной палаты РФ.
   Выставка «Нефтегаз», входящая в десятку крупнейших нефтегазовых смотров мира, предоставляет уникальную возможность производителям и поставщикам из разных стран продемонстрировать специалистам свое новейшее нефтегазовое и нефтеперерабатывающее оборудование и технологии, установить и расширить деловые контакты, обсудить широкий круг стоящих перед отраслью вопросов. С 2016 года выставка проводится ежегодно вместе с Национальным нефтегазовым форумом.
   Выставка и форум – это синергия участников, партнеров и всей отрасли, именно здесь представлены все новейшие разработки, встречаются производители и потребители, звучат трендовые доклады, проводятся самые значимые деловые мероприятия.
    </p>
    <p><img src="/news/37/1.jpg"></p>
    <p><img src="/news/37/2.jpg"></p>
    `,
  },
  {
    id: 36,
    title: "Районный выездной семинар",
    date: "18.04.2023",
    img: "/news/36/preview.jpg",
    preParagraph: `18 апреля 2023 года на базе ОАО «Беларускабель» состоялся районный выездной семинар «Всемирный день охраны труда». 
    В семинаре приняли участие руководители предприятий, организаций, руководители служб охраны труда, инженеры по охране труда.
  `,
    paragraph: `<p>18 апреля 2023 года на базе ОАО «Беларускабель» состоялся районный выездной семинар «Всемирный день охраны труда». 
    В семинаре приняли участие руководители предприятий, организаций, руководители служб охраны труда, инженеры по охране труда.
    Для присутствующих проведена экскурсия по предприятию, организована выставка спецодежды и спецобуви, прошло пленарное заседание, посвященное вопросам охраны труда.  
    </p>
    <p><img src="/news/36/preview.jpg"></p>
    <p><img src="/news/36/1.jpg"></p>
    <p><img src="/news/36/2.jpg"></p>
    <p><img src="/news/36/3.jpg"></p>
    `,
  },
  {
    id: 35,
    title: "Профсоюзная конференция",
    date: "23.03.2023",
    img: "/news/35/2_cr.jpg",
    preParagraph: `23 марта 2023 года в ОАО «Беларускабель» прошла профсоюзная конференция.
    Заслушаны отчеты за 2022 год о выполнении Коллективного договора, профсоюзного комитета , ревизионной комиссии, об исполнении сметы доходов и расходов, а также утверждена плановая смета профсоюзного бюджета на 2023 год.
    `,
    paragraph: `<p>23 марта 2023 года в ОАО «Беларускабель» прошла профсоюзная конференция.
    Заслушаны отчеты за 2022 год о выполнении Коллективного договора, профсоюзного комитета , ревизионной комиссии, об исполнении сметы доходов и расходов, а также утверждена плановая смета профсоюзного бюджета на 2023 год.
    Приятно отметить, что по итогам ежегодного республиканского конкурса на лучшую первичную профсоюзную организацию Белорусского профессионального союза работников отраслей промышленности «БЕЛПРОФМАШ» первичная профсоюзная организация ОАО «Беларускабель» заняла почетное 2-ое место.
    Грамоту первичной профсоюзной организации вручил председатель Гомельского областного объединения профсоюзов «БЕЛПРОФМАШ» Болошко Александр Владимирович.
    Поздравляем первичную профсоюзную организацию и всех ее членов с заслуженной наградой и желаем новых успехов и достижений!
    </p>
    <p><img src="/news/35/1.jpg"></p>
    <p><img src="/news/35/preview.jpg"></p>
    <p><img src="/news/35/2.jpg"></p>
    <p><img src="/news/35/3.jpg"></p>
    `,
  },
  {
    id: 34,
    title: "Шахматы 2023",
    date: "21.03.2023",
    img: "/news/34/preview.jpg",
    preParagraph: `21 марта 2023 г. представители ОАО «Беларускабель» приняли участие в командном чемпионате Мозырского района по шахматам в программе круглогодичной Спартакиады.`,
    paragraph: `<p>21 марта 2023 г. представители ОАО «Беларускабель» приняли участие в командном чемпионате Мозырского района по шахматам в программе круглогодичной Спартакиады.</p>
    <p><img src="/news/34/1.jpg"></p>
    <p><img src="/news/34/2.jpg"></p>
    <p><img src="/news/34/3.jpg"></p>
    <p><img src="/news/34/4.jpg"></p>
    `,
  },
  {
    id: 33,
    title: "Подведение итогов социально-экономического развития за 2022 год",
    date: "17.03.2023",
    img: "/news/33/preview.jpg",
    preParagraph: `17 марта 2023 года состоялось подведение итогов соревнования социально-экономического развития Мозырского района за 2022 год.
    ОАО «Беларускабель заняло второе место среди промышленных организаций Мозырского района.
  `,
    paragraph: `<p>17 марта 2023 года состоялось подведение итогов соревнования социально-экономического развития Мозырского района за 2022 год.
    ОАО «Беларускабель заняло второе место среди промышленных организаций Мозырского района.
    Диплом 2-й степени из рук руководства Мозырского района получил директор Шилов Виталий Петрович.
    Кроме того, предприятие стало лучшим по охране труда среди промышленных организаций Мозырского района.
    Поздравляем весь трудовой коллектив предприятия, желаем крепкого здоровья и новых свершений, успехов и достижений.
  </p>
    <p><img src="/news/33/1.jpg"></p>
    <p><img src="/news/33/preview.jpg"></p>
    <p><img src="/news/33/2.jpg"></p>
    <p><img src="/news/33/3.jpg"></p>
    `,
  },
  {
    id: 32,
    title: "Выставка «Cabex 2023»",
    date: "16.03.2023",
    img: "/news/32/preview_cr.jpg",
    preParagraph:
      "Представители руководства ОАО «Беларускабель» приняли участие в 21-ой международной выставке кабельно-проводниковой продукции, оборудования и материалов «Cabex 2023», которая прошла с 14 по 16 марта 2023 года в г. Москва, Россия.",
    paragraph: `<p>Представители руководства ОАО «Беларускабель» приняли участие в 21-ой международной выставке кабельно-проводниковой продукции, оборудования и материалов «Cabex 2023», которая прошла с 14 по 16 марта 2023 года в г. Москва, Россия.</p>
    <p><img src="/news/32/1.jpg"></p>
    <p><img src="/news/32/preview.jpg"></p>
    <p><img src="/news/32/2.jpg"></p>
    <p><img src="/news/32/3.jpg" style="width:100%"></p>
    `,
  },
  {
    id: 31,
    title: "Шашки 2023",
    date: "14.03.2023",
    img: "/news/31/preview.jpg",
    preParagraph:
      "14 марта 2023 г. представители ОАО «Беларускабель» приняли участие в командном чемпионате Мозырского района по шашкам в программе круглогодичной Спартакиады.",
    paragraph: `<p>14 марта 2023 г. представители ОАО «Беларускабель» приняли участие в командном чемпионате Мозырского района по шашкам в программе круглогодичной Спартакиады.</p>
    <p><img src="/news/31/1.jpg"></p>
    <p><img src="/news/31/2.jpg"></p>
    <p><img src="/news/31/3.jpg"></p>
    <p><img src="/news/31/preview.jpg"></p>`,
  },
  {
    id: 30,
    title: "Поздравление юбиляров",
    date: "10.03.2023",
    img: "/news/30/preview.jpg",
    preParagraph:
      "В ОАО «Беларускабель» стало хорошей традицией поздравление юбиляров с личными праздниками. Помимо теплых слов поздравлений от руководства и коллег, юбиляры получают от профкома предприятия Грамоту и единовременную выплату.",
    paragraph: `<p>В ОАО «Беларускабель» стало хорошей традицией поздравление юбиляров с личными праздниками. Помимо теплых слов поздравлений от руководства и коллег, юбиляры получают от профкома предприятия Грамоту и единовременную выплату.</p>
    <p>Так в марте 2023 года поздравили с 50-летием заместителя директора по снабжению и организации перевозок Камеша Владимира Александровича.</p>
    <p>Свои красивые даты отметили и милые дамы: контролер кабельных изделий ОТК Кадол Лилия Григорьевна и заместитель директора по идеологической работе, кадрам и социальным вопросам Фещенко Светлана Леонидовна.</p>
    <p><img src="/news/30/1.jpg"></p>
    <p><img src="/news/30/2.jpg"></p>
    <p><img src="/news/30/preview.jpg" style="width:100%"></p>`,
  },
  {
    id: 29,
    title: "Мероприятия к 8 марта",
    date: "08.03.2023",
    img: "/news/29/preview.jpg",
    preParagraph:
      "В ОАО «Беларускабель» в преддверии Дня женщин прошли поздравительные мероприятия.",
    paragraph: `<p>Подарки и поздравления получили женщины от мужчин-коллег, администрация предприятия подарила всем сотрудницам подарочные сертификаты в сеть магазинов «8марта» и денежные выплаты.</p>
    <p>Не обошелся, конечно же, праздник без яркого впечатляющего концерта от Гомельской областной филармонии «Самым обаятельным и привлекательным».</p>
    <p><img src="/news/29/preview.jpg"></p>
    <p><img src="/news/29/1.jpg"></p>
    <p><img src="/news/29/2.jpg"></p>
    <p><img src="/news/29/3.jpg"></p>`,
  },
  {
    id: 28,
    title: "Подведение итогов смотра-конкурса по охране труда за 2022 год",
    date: "06.03.2023",
    img: "/news/28/preview.jpg",
    preParagraph:
      "6 марта 2023 года в ОАО «Беларускабель» состоялось подведение ежегодного смотра-конкурса по охране труда между структурными подразделениями за 2022 год.",
    paragraph: `<p>6 марта 2023 года в ОАО «Беларускабель» состоялось подведение ежегодного смотра-конкурса по охране труда между структурными подразделениями за 2022 год.</p>
    <p>Коллективы-победители награждены грамотами и поощрены денежным вознаграждением.</p>
    <p><img src="/news/28/preview.jpg"></p>
    <p><img src="/news/28/1.jpg"></p>
    <p><img src="/news/28/2.jpg"></p>
    <p><img src="/news/28/3.jpg"></p>
    <p><img src="/news/28/4.jpg"></p>`,
  },
  {
    id: 27,
    title: "Лазерпарк",
    date: "24.02.2023",
    img: "/photogallery/240223/1.jpeg",
    preParagraph:
      "22 февраля 2023 года в рамках проходящего в Гомельской области комплекса дополнительных мер по профилактике безнадзорности и правонарушений несовершеннолетних, ко Дню защитников Отечества и Вооружённых Сил Республики Беларусь руководством ОАО «Беларускабель»  организовано и проведено мероприятие для детей работников предприятия в Лазерпарке.",
    paragraph: `<p>22 февраля 2023 года в рамках проходящего в Гомельской области комплекса дополнительных мер по профилактике безнадзорности и правонарушений несовершеннолетних, ко Дню защитников Отечества и Вооружённых Сил Республики Беларусь руководством ОАО «Беларускабель»  организовано и проведено мероприятие для детей работников предприятия в Лазерпарке.<p>
	Ребята с удовольствием поиграли в лазертаг в космоарене, на развлекательных автоматах, приняли участие в неоновом шоу, угостились сладкой ватой.<p>
	Дети и их родители получили массу удовольствия и позитива.
    <p><img src="/photogallery/240223/3.jpeg"></p>
    <p><img src="/photogallery/240223/4.jpeg"></p>
    <p><img src="/photogallery/240223/1.jpeg"></p>
    <p><img src="/photogallery/240223/2.jpeg"></p>`,
  },
  {
    id: 26,
    title: "Участие в выставке",
    date: "03.02.2023",
    img: "/photogallery/02022023/IMG_20230202_201237_284.jpg",
    preParagraph:
      "2 февраля 2023 года открытое акционерное общество «Беларускабель» приняло участие в выставке-презентации продукции, состоявшейся в Мозырском городском дворце культуры, в рамках праздничных мероприятий, посвящённых 85-летию Гомельской области.",
    paragraph: `<p>2 февраля 2023 года открытое акционерное общество «Беларускабель» приняло участие в выставке-презентации продукции, состоявшейся в Мозырском городском дворце культуры, в рамках праздничных мероприятий, посвящённых 85-летию Гомельской области.<br><br><img src="/photogallery/02022023/IMG_20230202_201237_284.jpg"/> <img style="padding-top: 20px" src="/photogallery/02022023/IMG_20230202_201400_710.jpg"/>`,
  },
  {
    id: 25,
    img: "/photogallery/300123/3.jpeg",
    title: "День памяти жертв Холокоста",
    date: "30.01.2023",
    preParagraph:
      "27 января 2023 года, в Международный день памяти жертв Холокоста, представители трудового коллектива, профсоюзной организации, БРСМ ОАО «Беларускабель» возложили цветы к памятным местам, связанным с этими трагическими событиями.",
    paragraph: `<p>27 января 2023 года, в Международный день памяти жертв Холокоста, представители трудового коллектива, профсоюзной организации, БРСМ ОАО «Беларускабель» возложили цветы к памятным местам, связанным с этими трагическими событиями.<p>
В Год мира и созидания очень важно бережно хранить историческую память.
    <p><img src="/photogallery/300123/3.jpeg"></p>
    <p><img src="/photogallery/300123/4.jpeg"></p>
    <p><img src="/photogallery/300123/1.jpeg"></p>
    <p><img src="/photogallery/300123/2.jpeg"></p>
`,
  },
  {
    id: 24,
    img: "/photogallery/170123/3.jpg",
    title: "День освобождения Мозырщины",
    date: "17.01.2023",
    preParagraph:
      "14 января – священный день для жителей Мозыря и Мозырского района. В суровом зимнем 1944 году Красная Армия освободила нашу Мозырщину от немецко-фашистских захватчиков. Освобождение произошло в результате Калинковичско-Мозырской наступательной операции войск левого крыла Белорусского фронта.",
    paragraph: `<p>14 января – священный день для жителей Мозыря и Мозырского района. В суровом зимнем 1944 году Красная Армия освободила нашу Мозырщину от немецко-фашистских захватчиков. Освобождение произошло в результате Калинковичско-Мозырской наступательной операции войск левого крыла Белорусского фронта. В ней принимали участие 61-я армия П. А. Белова, 65-я армия П. И. Батова и 16-я воздушная армия С. И. Руденко.<p>
Ежегодно в этот день мы отдаем дань памяти тем, кто подарил нам мир, свободу и независимость. Нынешний год не стал исключением. Администрация, члены трудового коллектива, представители молодежи  ОАО «Беларускабель» приняли участие в митинге, посвященном 79-й годовщине освобождения города и района от немецко-фашистских захватчиков.<p>
	Мы не забудем вас, солдаты Великой Отечественной войны! Выражаем безмерную благодарность фронтовикам и труженикам тыла, отстоявшим наше право на жизнь в смертельной схватке с врагом. Желаем вам крепкого здоровья, мира, тепла окружающих вас людей! <p>
В 2023 году, объявленным Годом мира и созидания, наша задача – сделать всё возможное для укрепления ратного и трудового подвига старшего поколения новыми достижениями, направленными на укрепление стабильности и суверенитета нашей страны. 
    <p><img src="/photogallery/170123/3.jpg"></p>
    <p><img src="/photogallery/170123/4.jpg"></p>
    <p><img src="/photogallery/170123/5.jpg"></p>
    <p><img src="/photogallery/170123/6.jpg"></p>
    <p><img src="/photogallery/170123/7.jpg"></p>
    <p><img src="/photogallery/170123/8.jpg"></p>
`,
  },
  {
    id: 23,
    img: "/photogallery/170123/2.jpg",
    title: "Колядки 2023",
    date: "17.01.2023",
    preParagraph:
      "13 января 2023 года учащиеся учреждения образования «Средняя школа № 5 г. Мозыря» выступили  в ОАО «Беларускабель» с искрометной колядной программой, включающей костюмированное представление, веселые праздничные песни, зажигательные танцы, подарив работникам предприятия веселое колядное настроение, массу позитива и порцию хорошего настроения.",
    paragraph: `<p>13 января 2023 года учащиеся учреждения образования «Средняя школа № 5 г. Мозыря» выступили  в ОАО «Беларускабель» с искрометной колядной программой, включающей костюмированное представление, веселые праздничные песни, зажигательные танцы, подарив работникам предприятия веселое колядное настроение, массу позитива и порцию хорошего настроения.<p>
За свой талант и неподдельные эмоции ребята получили небольшие сувениры и сладкие подарки, а также бурю аплодисментов.
    <p><img src="/photogallery/170123/1.jpg"></p>
    <p><img src="/photogallery/170123/2.jpg"></p>
`,
  },
  {
    id: 22,
    img: "defaultIcon.png",
    title: "МЕЖДУНАРОДНЫЙ ДЕНЬ ЭНЕРГОСБЕРЕЖЕНИЯ",
    date: "11.11.2022",
    preParagraph:
      "11 ноября 2022 г. отмечается Международный день энергосбережения.",
    paragraph: `<p>11 ноября 2022 г. отмечается Международный день энергосбережения.</p>
    <p>Открытое акционерное общество «Беларускабель» присоединилось к республиканской информационно-образовательной акции
     «Беларусь – энергоэффективная страна». Девиз акции – «В едином движении к лучшему!», а основная задача – повысить осведомленность населения о 
     возможных способах и методах повышения эффективности использования энергоресурсов, в том числе и в повседневной жизни в быту, 
     что является одной из важных мер по улучшению благосостояния граждан и экономического роста страны в целом.</p>
     <img src="/energo.jpg"/>`,
  },
  {
    id: 21,
    img: "/photogallery/311022/1.jpeg",
    title: "Информационные встречи",
    date: "31.10.2022",
    preParagraph:
      "25 октября 2022 года в ОАО «Беларускабель» состоялась информационная встреча с трудовым коллективом.",
    paragraph: `<p>25 октября 2022 года в ОАО «Беларускабель» состоялась информационная встреча с трудовым коллективом.<p>
Перед собравшимися выступила депутат палаты представителей Национального собрания Республики Беларусь Назаренко Валентина Алексеевна, которая осветила тему продовольственной безопасности страны, механизм формирования и регулирования цен, важность развития агропромышленного комплекса.<p>
Обсуждались также вынесенные на общественное обсуждение два законопроекта:<br>
проект Закона Республики Беларусь «О Всебелорусском народном собрании»;<br>
проект Закона Республики Беларусь «Об изменении Избирательного кодекса Республики Беларусь».<p>
В ходе обсуждения законопроектов Валентина Алексеевна обозначила ключевые подходы к формированию Всебелорусского народного собрания и его органов, а также компетенцию ВНС.<p>
Директор ОАО «Беларускабель» Шилов Виталий Петрович довел коллективу итоги работы за девять месяцев текущего года и перспективы развития предприятия.<p>
Представитель государственного предприятия «Стравита» Пчёлка Татьяна Михайловна  довела новый механизм добровольного страхования дополнительной накопительной пенсии.<p>
Заместитель директора по идеологической работе,  кадрам и социальным вопросам Фещенко Светлана Леонидовна призвала работников предприятия быть бдительными в условиях участившихся случаев кибермошенничества.<p>
28 октября с руководителями структурных подразделений предприятия прошла информационная встреча с участием представителя Органов внутренних дел. Были затронуты вопросы профилактики телефонного мошенничества, краж из дач, преступлений против половой неприкосновенности и половой свободы несовершеннолетних.
    <p><img src="/photogallery/311022/1.jpeg"></p>
    <p><img src="/photogallery/311022/2.jpeg"></p>
    <p><img src="/photogallery/311022/3.jpeg"></p>
    <p><img src="/photogallery/311022/4.jpeg"></p>
`,
  },
  {
    id: 20,
    img: "/photogallery/241022/1.jpeg",
    title: "Неделя родительской любви",
    date: "24.10.2022",
    preParagraph:
      "В Беларуси стало традиционным в православный праздник – Покров Пресвятой Богородицы отмечать День матери. В этом году  21 октября впервые отпраздновали новый праздник – День отца.",
    paragraph: `<p>В Беларуси стало традиционным в православный праздник – Покров Пресвятой Богородицы отмечать День матери. В этом году  21 октября впервые отпраздновали новый праздник – День отца.  И это правильно, ведь, как сказал Александр Григорьевич Лукашенко: «В современном мире именно личный  пример, поддержка и забота отца с детства воспитывает ответственность, трудолюбие, уважение к старшим, готовность служить Родине и защищать свою землю.».<p>
	На самом деле, для гармоничного семейного счастья ребёнку необходимы мама и папа. В 2022 году между двумя семейно-ориентированными праздниками мы впервые отмечаем неделю Родительской любви.<p>
	В ОАО «Беларускабель» отметили её поздравлениями, подарками для мужчин  и женщин, праздничными открытками, украшениями, созданием коллажей и роликов, а также  концертной программой «Пусть всегда будет мама!».
	В Год исторической памяти очень важно хранить и поддерживать семейные ценности.
    <p><img src="/photogallery/241022/1.jpeg"></p>
    <p><img src="/photogallery/241022/2.jpeg"></p>
    <p><img src="/photogallery/241022/3.jpeg"></p>
    <p><img src="/photogallery/241022/4.jpeg"></p>
    <p><img src="/photogallery/241022/5.jpeg"></p>
    <p><img src="/photogallery/241022/6.jpeg"></p>
    <p><img src="/photogallery/241022/7.jpeg"></p>
    <p><img src="/photogallery/241022/8.jpeg"></p>
    <p><img src="/photogallery/241022/9.jpeg"></p>
    <p><img src="/photogallery/241022/10.jpeg"></p>
`,
  },
  {
    id: 19,
    img: "/photogallery/211022/1.jpeg",
    title: "Благодарность за сына",
    date: "20.10.2022",
    preParagraph:
      "Благодарственное письмо от руководства предприятия и профсоюзного комитета получил 22 октября 2022 года, в День отца, станочник широкого профиля ремонтно-механического участка Пархоменко Сергей Валерьевич за хорошее воспитание сына.",
    paragraph: `<p>Благодарственное письмо от руководства предприятия и профсоюзного комитета получил 22 октября 2022 года, в День отца, станочник широкого профиля ремонтно-механического участка Пархоменко Сергей Валерьевич за хорошее воспитание сына.<p>
Пархоменко Максим Сергеевич прибыл в 2022 году для работы на предприятии в качестве молодого специалиста. За короткий период работы молодой инженер-энергетик зарекомендовал себя ответственным, исполнительным, дисциплинированным работником. Будучи членом БРСМ и Молодежного Совета, принимает активное участие в общественной жизни предприятия, в культурно-массовых и спортивных мероприятиях.<p>
Совсем скоро Максим отправится на службу в Вооружённые Силы Республики Беларусь. Пожелаем ему хорошей службы на благо Родины, здоровья, мира и благоденствия!
    <p><img src="/photogallery/211022/1.jpeg"></p>
`,
  },
  {
    id: 18,
    img: "/photogallery/201022/2.jpeg",
    title: "Международный день повара",
    date: "20.10.2022",
    preParagraph:
      "Ежегодно 20 октября свой профессиональный праздник – День повар – отмечают повара и кулинары  всего мира.",
    paragraph: `<p>Ежегодно 20 октября свой профессиональный праздник – День повар – отмечают повара и кулинары  всего мира.<p>
	Столовая ОАО «Беларускабель» в рабочие дни  гостеприимно распахивает свои двери не только для работников предприятия, но и для иных посетителей. Сюда ходят обедать также работники близлежащих учреждений и организаций.
	Наши повара и кондитер каждый раз удивляют своих клиентов вкусными разнообразными блюдами. Все работники встречают посетителей улыбкой и радуют доброжелательным отношением и хорошим обслуживанием.<p>
	Наша столовая принимает заказы на изготовление кулинарных блюд и кондитерских изделий, на проведение торжеств и поминальных обедов. Кстати, по договоренности можно провести мероприятие  и в выходной день.<p>
	Поздравляем работников общепита с праздником! Желаем крепкого здоровья, мира, счастья, любви и ждём от них вкусных блюд!

    <p><img src="/photogallery/201022/2.jpeg"></p>
`,
  },
  {
    id: 17,
    img: "/photogallery/201022/1.jpeg",
    title: "Легкоатлетический кросс",
    date: "20.10.2022",
    preParagraph:
      "15 октября 2022 года представители трудового коллектива, молодёжных ОАО «Беларускабель» приняли участие в открытом чемпионате Мозырского района по осеннему легкоатлетическому кроссу, который состоялся в лесопарке «Молодёжный».",
    paragraph: `<p>15 октября 2022 года представители трудового коллектива, молодёжных ОАО «Беларускабель» приняли участие в открытом чемпионате Мозырского района по осеннему легкоатлетическому кроссу, который состоялся в лесопарке «Молодёжный».<p>
	Очередной раз есть и призёры. В личном первенстве среди женщин успехов добилась Соловей Галина Дмитриевна. Заняв второе место в своей возрастной категории. <p>
	Поздравляем наших любителей спорта и желаем новых побед!
    <p><img src="/photogallery/201022/1.jpeg"></p>
`,
  },
  {
    id: 16,
    img: "defaultIcon.png",
    title: "Двойной праздник",
    date: "22.09.2022",
    preParagraph:
      "17 сентября 2022 г. сотрудники ОАО «Беларускабель» приняли участие в праздничных мероприятиях, посвящённых Дню народного единства и Дню  города Мозыря.",
    paragraph: `<p>17 сентября 2022 г. сотрудники ОАО «Беларускабель» приняли участие в праздничных мероприятиях, посвящённых Дню народного единства и Дню  города Мозыря.<p>
	Второй год подряд сентябрь для мозырян становится знаковым месяцем. Вместе со всей страной мы отмечаем День народного единства, праздник, который занял важное место в календаре государственных праздников, праздник, символизирующий патриотизм, взаимопомощь, единение нашего народа. Символично, что в этот день и наш родной город отметил свое 867-летие.<p>
	По доброй традиции в день рождения города на главной сцене праздника чествовали мозырян. За многолетний добросовестный труд, высокий профессионализм и значительный вклад в социально-экономическое развитие Мозырского района награждены работники предприятия:<p>
Почетной грамотой Мозырского районного исполнительного комитета награждена оплётчик проводов и кабелей производственного цеха Козловская Валентина Арсеньевна;<p>
Почетной грамотой Мозырского районного Совета депутатов награждена армировщик кабельных изделий производственного цеха Бровкина Елена Михайловна.<p>
Чествовали на празднике и трудовые династии. Трудовую династию кабельного завода представляла семья Шульги: Наталья Ивановна, Дмитрий Васильевич, Алексей Васильевич и Татьяна Викторовна. Общий стаж династии составляет более 75 лет.<p>
Подвели на празднике итоги конкурса на лучшее благоустройство и озеленение территории Мозырского района. За особый вклад в благоустройство и озеленение территории Мозырского района открытому акционерному обществу «Беларускабель» объявлена Благодарность Мозырского районного исполнительного комитета.
Поздравляем победителей. Так держать!`,
  },
  {
    id: 15,
    img: "/photogallery/190922/1.jpeg",
    title: "Челлендж рукопожатий",
    date: "19.09.2022",
    preParagraph:
      "Челлендж рукопожатий, объявленный БРСМ накануне Дня народного единства, поддержали ОАО «Беларускабель» и учреждение образования «Средняя общеобразовательная школа № 5 г. Мозыря».",
    paragraph: `<p>Челлендж рукопожатий, объявленный БРСМ накануне Дня народного единства, поддержали ОАО «Беларускабель» и учреждение образования «Средняя общеобразовательная школа № 5 г. Мозыря».
    <p><img src="/photogallery/190922/1.jpeg"></p>
`,
  },
  {
    id: 14,
    img: "defaultIcon.png",
    title: "День народного единства",
    date: "14.09.2022",
    preParagraph:
      "15 сентября 2022 года в ОАО «Беларускабель» прошёл флэшмоб, приуроченный ко Дню народного единства.",
    paragraph: `<p>15 сентября 2022 года в ОАО «Беларускабель» прошёл флэшмоб, приуроченный ко Дню народного единства.<p>
В мероприятии приняли участие представители молодёжных организаций предприятия.<p>
Корпоративный девиз предприятия «Соединяя миры» умесно вписался в текст произносимых слов: <br>
«В день народного единства  <br>
Мир и дружба нам нужны: <br>
Проводами связь наладим -  <br>
И соединим миры!».`,
  },
  {
    id: 13,
    img: "/photogallery/120922/1.jpeg",
    title: "Беларусь адзiная",
    date: "12.09.2022",
    preParagraph:
      "7 сентября 2022 года представители администрации ОАО «Беларускабель» в составе делегации Мозырского района  приняли участие в областном общественно-патриотическом форуме «Беларусь адзiная», который прошёл в преддверии Дня народного единства в г. Речица Гомельской области.",
    paragraph: `<p>7 сентября 2022 года представители администрации ОАО «Беларускабель» в составе делегации Мозырского района  приняли участие в областном общественно-патриотическом форуме «Беларусь адзiная», который прошёл в преддверии Дня народного единства в г. Речица Гомельской области. <p>
В нынешнем году форум прошёл в  соответствии с тематикой Года исторической памяти. <p>
Среди экспертов форума – председатель правления республиканского государственно-общественного общества «Знание» Вадим Гигин,  ректор Академии управления при Президенте Республики Беларусь Вячеслав Данилович, председатель Постоянной комиссии по образованию, культуре и науке Палаты представителей Национального собрания Беларуси, доктор исторических наук, профессор Игорь Марзалюк и другие.<p>
В условиях информационных и гибридных войн чрезвычайно важно противостоять навязыванию искаженных, чужих представлений об историческом пути и перспективах белорусского народа. 
    <p><img src="/photogallery/120922/1.jpeg"></p>
    <p><img src="/photogallery/120922/2.jpeg"></p>
    <p><img src="/photogallery/120922/3.jpeg"></p>
`,
  },
  {
    id: 12,
    img: "/photogallery/280722/1.png",
    title: "Кабель.РФ® и «Беларускабель» стали информационными партнерами",
    date: "28.07.2022",
    preParagraph:
      "28 июля 2022 года компания Кабель.РФ® и предприятие «Беларускабель» подписали соглашение об информационном сотрудничестве.",
    paragraph: `
    <p><img src="/photogallery/280722/1.png"></p><p>28 июля 2022 года компания <a href='https://cable.ru'>Кабель.РФ®</a> и предприятие «Беларускабель» подписали соглашение об информационном сотрудничестве.
По его условиям партнеры планируют реализовать ряд совместных мероприятий, целью которых является повышение узнаваемости брендов в сети Интернет. <p>
На официальном сайте Cable.ru уже создана <a href="https://cable.ru/zavod/belaruscab.php">персональная страница «Беларускабель»</a>. Благодаря этому пользователи смогут оперативно получить базовые сведения о заводе, узнать об основных направлениях деятельности и ознакомиться с фотографиями производства. <p>
Сотрудничество будет способствовать и оперативной публикации актуальных новостей в соответствующем разделе сайта. Новинки продукции, передовые разработки, участие в тематических выставках и конференциях – именно такая информация планируется к размещению.  <p>
В свою очередь, на официальном сайте завода «Беларускабель» также будет опубликована общая информация о партнере и логотип компании Кабель.РФ®.<p>
ОАО «Беларускабель» - значимое предприятий Республики Беларусь по изготовлению кабельно-проводниковой продукции для различных сфер промышленности, таких как радиоэлектроника, электротехника, строительство, связь, приборостроение и телекоммуникация. Ежемесячно завод выпускает более 150 видов кабеля. 
Кабель.РФ® – одна из ведущих мультибрендовых интернет-площадок для продажи электротехнической и общепромышленной продукции в России и странах СНГ. Компания реализует кабельно-проводниковую продукцию и сопутствующие товары для монтажа и прокладки, опоры, низковольтное и светотехническое оборудование, электродвигатели, подшипники, насосы, редукторы,  транспортерные ленты, теплотехнику, цепи, ремни приводные, рукава и шланги, стропы и многое другое. На сайте Cable.ru регулярно публикуются новости из мира электротехники, тематические статьи и другие информационные материалы.`,
  },
  {
    id: 11,
    img: "/photogallery/200522/1.jpeg",
    title: "Профориентационная экскурсия",
    date: "20.05.2022",
    preParagraph:
      "18 мая 2022 г. в ОАО «Беларускабель» в рамках образовательно-просветительского проекта «Профориентационные экскурсии – профессии наших родителей» состоялась встреча с учащимися государственного учреждения образования «Средняя школа № 6 г. Мозыря».",
    paragraph: `<p>18 мая 2022 г. в ОАО «Беларускабель» в рамках образовательно-просветительского проекта «Профориентационные экскурсии – профессии наших родителей» состоялась встреча с учащимися государственного учреждения образования «Средняя школа № 6 г. Мозыря».<p>В ходе мероприятия ребят ознакомили с производством кабельной и полупроводниковой продукции и перспективами его развития, конкретными профессиями, имеющимися на предприятии.<p>Экскурсия помогла учащимся расширить представление о работе предприятия, дала возможность увидеть, какие профессии и специальности востребованы, а также где и как их можно получить. Это пригодится им в выборе профессии.<p>Будем рады видеть вас, ребята, в дальнейшем нашими работниками!
    <p><img src="/photogallery/200522/1.jpeg"></p>
    <p><img src="/photogallery/200522/2.jpeg"></p>
    <p><img src="/photogallery/200522/3.jpeg"></p>
    <p><img src="/photogallery/200522/4.jpeg"></p>
    <p><img src="/photogallery/200522/5.jpeg"></p>
    <p><img src="/photogallery/200522/6.jpeg"></p>`,
  },
  {
    id: 10,
    img: "/photogallery/260422/1.jpeg",
    title: "Чернобыль – мы обязаны знать и помнить",
    date: "26.04.2022",
    preParagraph:
      "26 апреля 2022 года, в день Чернобыльской трагедии, администрация и профсоюзный комитет ОАО «Беларускабель» чествовали работников предприятия, принимавших участие в ликвидации последствий аварии на ЧАЭС.",
    paragraph: `<p>26 апреля 2022 года, в день Чернобыльской трагедии, администрация и профсоюзный комитет ОАО «Беларускабель» чествовали работников предприятия, принимавших участие в ликвидации последствий аварии на ЧАЭС. Таковых на предприятии трудится 8 человек. Были высказаны слова уважения и глубокой признательности за проявленные смелость и отвагу. Была оказана материальная помощь данной категории работников.<p>В полдень представители трудового коллектива и общественных организаций  ОАО «Беларускабель» в числе других мозырян собрались в сквере памяти «Жертвам Чернобыля», чтобы почтить память героев, которые ценой своего здоровья, а порой и жизни, спасли нас от разрушительных последствий.<p>В год исторической памяти особенно важно сохранить память о тех событиях, ведь масштаб и значение трагедии на Чернобыльской АЭС сложно переоценить, как и мужество и героизм тех, кто вступил в борьбу с вышедшим из-под контроля мирным атомом.<p><b>Досье  к 36-й годовщине аварии на Чернобыльской АЭС:<br>Материал из Википедии — свободной энциклопедии</b></p><p>Авария на Черно́быльской АЭС 26 апреля 1986 года (также известна как катастрофа на Чернобыльской АЭС, чернобыльская авария, чернобыльская катастрофа или просто Чернобыль) — разрушение реактора четвёртого энергоблока Чернобыльской атомной электростанции, расположенной около города Припять (Украинская ССР, ныне — Украина).<p>Разрушение носило взрывной характер, реактор был полностью разрушен, а в окружающую среду выброшено большое количество радиоактивных веществ. Авария расценивается как крупнейшая в своём роде за всю историю атомной энергетики, как по предполагаемому количеству погибших и пострадавших от её последствий людей, так и по экономическому ущербу.<p>В течение первых трёх месяцев после аварии скончался 31 человек, ещё 19 смертей с 1987 по 2004 год предположительно можно отнести к её прямым последствиям. 134 человека из числа ликвидаторов перенесли острую лучевую болезнь той или иной степени тяжести. Высокие дозы облучения людей, в основном из числа аварийных работников и ликвидаторов, послужили или могут послужить причиной четырёх тысяч дополнительных смертей от отдалённых последствий облучения. Тем не менее эти цифры существенно меньше того количества жертв, которое приписывается чернобыльской катастрофе общественным мнением.<p>В отличие от бомбардировок Хиросимы и Нагасаки, взрыв напоминал очень мощную «грязную бомбу» — основным поражающим фактором стало радиоактивное загрязнение. Облако, образовавшееся от горящего реактора, разнесло различные радиоактивные материалы, прежде всего радионуклиды йода и цезия, по большей части Европы. Наибольшие выпадения вблизи реактора отмечались на территориях, относящихся к Белоруссии, Российской Федерации и Украине[4]. Из 30-километровой зоны отчуждения вокруг АЭС было эвакуировано всё население — более 115 тысяч человек. Для ликвидации последствий были мобилизованы значительные ресурсы, более 500 тысяч человек участвовали в ликвидации последствий аварии.<p>Чернобыльская авария стала событием большого общественно-политического значения для СССР. Всё это наложило определённый отпечаток на ход расследования её причин. У специалистов нет единого мнения о точных причинах аварии, версии разных специалистов-атомщиков сходны в общих чертах и различаются в конкретных механизмах возникновения и развития аварийной ситуации.
<p><img src="/photogallery/260422/1.jpeg"></p>
<p><img src="/photogallery/260422/2.jpeg"></p>
<p><img src="/photogallery/260422/3.jpeg"></p>
<p><img src="/photogallery/260422/4.jpeg"></p>
<p><img src="/photogallery/260422/5.jpeg"></p>
<p><img src="/photogallery/260422/6.jpeg"></p>`,
  },
  {
    id: 9,
    img: "/photogallery/140422/20220413_083951_copy.jpeg",
    title: "Всемирный день здоровья",
    date: "14.04.2022",
    preParagraph:
      "В рамках мероприятий, приуроченных Всемирному дню здоровья, работники ОАО «Беларускабель» прошли диспансерный осмотр специалистами учреждения здравоохранения «Мозырская центральная городская поликлиника»  на   базе своего здравпункта.",
    paragraph: `<p>В рамках мероприятий, приуроченных Всемирному дню здоровья, работники ОАО «Беларускабель» прошли диспансерный осмотр специалистами учреждения здравоохранения «Мозырская центральная городская поликлиника»  на   базе своего здравпункта.
<p><img src="/photogallery/140422/20220413_083951_copy.jpeg"></p>
<p><img src="/photogallery/140422/20220413_084204_copy.jpeg"></p>
<p><img src="/photogallery/140422/20220413_085802_copy.jpeg"></p>`,
  },
  {
    id: 8,
    img: "/photogallery/26012022/20220120_150628-min.jpg",
    title: "Об изменении Конституции и приоритетных направлениях развития",
    date: "26.01.2022",
    preParagraph:
      "20 января 2022 года в ОАО «Беларускабель» состоялся открытый диалог «Об изменении Конституции и приоритетных направлениях развития».",
    paragraph: `<p>20 января 2022 года в ОАО «Беларускабель» состоялся открытый диалог «Об изменении Конституции и приоритетных направлениях развития».
<p>В качестве эксперта выступил председатель суда Мозырского района Стрельченко Анатолий Николаевич.
Открыла мероприятие заместитель директора по идеологической работе,  кадрам и социальным вопросам. Фещенко Светлана Леонидовна отметила, что 27 февраля 2022 года состоится республиканский референдум по вопросу внесения изменений и дополнений в Конституцию Республики Беларусь. 27 декабря 2021 г. проект обновленного Основного Закона вынесен на всенародное обсуждение. 
<p><img src="/photogallery/26012022/20220120_150628-min.jpg"></p>
<p><img src="/photogallery/26012022/20220120_150730-min.jpg"></p>
<p>С этого времени тема конституционного строительства нашла широкий отклик в белорусском обществе. Она также активно обсуждается в трудовых коллективах, так как перемены продиктованы веянием времени. Это запрос на социальное государство, на сохранение гарантий, которое государство предоставляет гражданам, на сохранение мира и стабильности, исторической памяти, национальных и духовных традиций нашего народа, сохранение институтов брака и семьи. Обновленная Конституция должна стать тем фундаментом, на котором будет строиться наше будущее.
Обсуждение проекта Основного Закона показывает, что равнодушных в нашем обществе нет. Многие из нас пережили развал большого государства – Советского Союза. И мы не хотим потерь свою страну еще раз.
<p>Стрельченко А.Н. компетентно рассказал присутствующим о нововведениях в Основной Закон. Анатолий Николаевич отметил, что Конституция является основой построения Республики Беларусь как унитарного демократического социального правового государства. Внесение изменений обусловлено объективной динамикой общественно-политических и экономических процессов. Они будут направлены на сохранение государственности и мира, гражданского согласия на белорусской земле. В обновленной преамбуле мы сообща желаем своей стране мира, народу – процветания, каждому гражданину – благополучия. Она дополнена положениями о сохранении национальной самобытности и суверенитета, культурных и духовных традиций, социально справедливого общества.
<p>Внимание присутствующих было обращено на включение в Конституцию положений, направленных на сохранение исторической правды и памяти о Великой Отечественной войне, а также на исключение военной агрессии с территории Республики Беларусь.
<p>Принципиальной позицией является сохранение социальной направленности государственной политики. Трудовые и экономические гарантии, защита права собственности, доступность образования, содействие каждому гражданину в приобретении своего жилья остались неизменными. Однако особое внимание уделено воспитанию традиционных семейных ценностей, поддержке семей с детьми, детей-сирот и детей, оставшихся без попечения родителей, а также молодежи, заботе государства о пожилых людях и инвалидах.
<p>В ходе проведения мероприятия было обращено внимание на изменения и дополнения, касающиеся повышения социальной ответственности. Государство, создавая условия для нормальной жизнедеятельности общества, вправе рассчитывать на то, что ему будет оказываться поддержка и отдельно взятым гражданином, в том числе гражданин будет ответственен  и за свое здоровье.
<p>Отдельное внимание уделено Всебелорусскому народному собранию как высшему представительному органу народовластия, который будет наделен важнейшими государственными полномочиями. Установление ВНС такого статуса будет способствовать дальнейшему укреплению демократических начал государства, развитию народного представительства, реализации конституционного принципа народовластия.
<p>Принимая во внимание широкий объем полномочий Всебелорусского народного собрания, изменяются полномочия других государственных органов и должностных лиц, в том числе Главы государства.
<p>В отношении должности Президента предлагается:<br>
ужесточение требований к кандидатам на высшую государственную должность (повышается возраст – не моложе 40 лет, увеличивается период постоянного проживания в стране перед выборами с 10 до 20 лет, устанавливается запрет на иностранное гражданство или иностранный вид на жительство);<br>
введение ограничения по срокам для Главы государства (не более двух);<br>
упрощение процедуры импичмента (новое основание – систематическое либо грубое нарушение Конституции), а также предоставление гражданам права инициировать эту процедуру (не менее 150 тысяч);<br>
упразднение декрета как вида нормативного правового акта;<br>
придание указам подзаконного характера;<br>
наделение Президента правом назначать помощников и уполномоченных по различным вопросам, требующим особого внимания со стороны государства;<br>
закрепление статуса Президента, прекратившего исполнение своих полномочий (при его согласии он станет членом Совета Республики, а также делегатом ВНС).
<p>Определенные изменения предусмотрены в отношении системы местного управления и самоуправления, в частности: как и для парламентариев, для депутатов на местах устанавливается пятилетний срок полномочий.
<p>Во время обсуждений проекта Основного Закона  рассмотрены изменения, касающихся избирательного процесса, а также судебной системы.
<p>Благодаря Конституции в правовом поле закрепляются столпы Белорусской модели общественного развития:<br>
сильное государство;<br>
социально-ориентированная рыночная экономика;<br>
традиционные христианские ценности.
<p>Завершая встречу, директор ОАО «Беларускабель» Шилов Виталий Петрович подчеркнул, что долг каждого из нас – принять участие в республиканском референдуме, выразив свое волеизъявление по проекту изменений и дополнений в Конституцию Республики Беларусь.`,
  },
  {
    id: 7,
    img: "/photogallery/13012022/20220113_142748-min.jpg",
    title: "Обсуждаем проект Основного Закона государства вместе с профсоюзом",
    date: "13.01.2022",
    preParagraph:
      "13 января 2022 года в ОАО «Беларускабель» состоялось заседание профсоюзного комитета. Одним из вопросов рассмотрен проект изменений и дополнений Конституции Республики Беларусь.",
    paragraph: `<p>Актив первичной профсоюзной организации Открытого акционерного общества «Беларускабель» г. Мозырь Белорусского профессионального союза работников отраслей промышленности «БЕЛПРОФМАШ» уверен, что обновленный Основной Закон государства – это закон будущего, он отвечает современным вызовам.</p>
    <img src="/photogallery/13012022/20220113_142748-min.jpg"><p>Важно, что сохранятся основные ориентиры нашего государства: социальная справедливость, гуманизм, традиционные ценности белорусского народа и механизмы управления, способствующие   динамичному развитию страны и общественному прогрессу.<p>Напоминаем, что с проектом изменений и дополнений Конституции Республики Беларусь можно ознакомиться на Национальном правовом интернет-портале: https://pravo.by/pravovaya-informatsiya/vsenarodnoe-obsuzhdenie-proekta-konstitutsii-respubliki-belarus/.<p>Мнения граждан относительно содержания проекта изменений и дополнений, а также возможные предложения по его совершенствованию направляются в Национальный центр правовой информации:<br>
    • по электронной почте sbor@ncpi.gov.by;<br>
    • посредством электронной формы;<br>
    • в письменном виде по адресу 220030, г. Минск, ул. Берсона, 1а, НЦПИ, с пометкой «Конституция».<br>
Поступившие материалы будут обобщаться и систематизироваться Национальным центром правовой информации. `,
  },
  {
    id: 6,
    title: "Обсуждаем Основной Закон вместе",
    date: "10.01.2022",
    img: "defaultIcon.png",
    preParagraph:
      "В настоящее время вся страна обсуждает проект изменений и дополнений Конституции Республики Беларусь. Не могли остаться в стороне и работники ОАО «Беларускабель». Ведь  это -  Основной Закон, по которому мы будем жить в будущем. Изменения в Конституцию Республики Беларусь продиктованы временем. Мы живем в мирной и стабильной стране,  нам важно её будущее, и хотим, чтобы так было и далее.",
    paragraph: `<p>В настоящее время вся страна обсуждает проект изменений и дополнений Конституции Республики Беларусь. Не могли остаться в стороне и работники ОАО «Беларускабель». Ведь  это -  Основной Закон, по которому мы будем жить в будущем. Изменения в Конституцию Республики Беларусь продиктованы временем. Мы живем в мирной и стабильной стране,  нам важно её будущее, и хотим, чтобы так было и далее.<p>На предприятии созданы тематические точки и уголки, где размещен проект Конституции Республики Беларусь, а также мнения белорусов по изменениям и дополнениям в неё.<p>Итоговое слово белорусы выскажут на референдуме. Это не окончательный вариант основного Закона. Как ранее уже отмечал Президент Беларуси Александр Григорьевич Лукашенко, если граждане внесут конструктивные предложения, их обязательно учтут и проект изменят.<p>Информация для работников предприятия о том, где можно ознакомиться с проектом Конституции Республики Беларусь, а также куда и в какой форме можно отправлять мнения граждан, размещена на информационных стендах, на официальном интернет-сайте организации в рубрике «Новости» за 31.12.2021, на межсетевом диске Н.<p>6 января 2021 г. представители трудового коллектива предприятия приняли участие в диалоговой площадке «Конституция: в будущее вместе».<p>Работники ОАО «Беларускабель» уверены в том, что наш обновленный Основной Закон дает много гарантий сохранения мира и стабильности, благополучия граждан, сохранения исторической памяти и духовно-нравственных традиций, в том числе института семьи и брака. Актуальным является закрепление понятия брака как союза между мужчиной и женщиной.<p>Поправки Основного Закона государства отражают интересы большинства граждан, содержат множество ключевых изменений по улучшению работы исполнительных и законодательных органов. В документе появились новации, направленные на  поддержку реализации научно-технических проектов, внедрение инноваций и развитие атомной энергетики.<p>Напоминаем, что с проектом изменений и дополнений Конституции Республики Беларусь можно ознакомиться на Национальном правовом интернет-портале: https://pravo.by/pravovaya-informatsiya/vsenarodnoe-obsuzhdenie-proekta-konstitutsii-respubliki-belarus/.<p>Мнения граждан относительно содержания проекта изменений и дополнений, а также возможные предложения по его совершенствованию направляются в Национальный центр правовой информации:<br>
    • по электронной почте sbor@ncpi.gov.by;<br>
    • посредством электронной формы;<br>
    • в письменном виде по адресу 220030, г. Минск, ул. Берсона, 1а, НЦПИ, с пометкой «Конституция».<br>
Поступившие материалы будут обобщаться и систематизироваться Национальным центром правовой информации.
<p>
<img src="/photogallery/01102022/20220106_105711-min.jpg" ><br><br>
<img src="/photogallery/01102022/20220106_115810-min.jpg" ><br><br>
<img src="/photogallery/01102022/20220106_140218-min.jpg" ><br><br>
<img src="/photogallery/01102022/20220106_141841-min.jpg" ><br><br>
<img src="/photogallery/01102022/20220106_144815-min.jpg" ><br><br>
<img src="/photogallery/01102022/20220106_151952-min.jpg" ><br><br>

</p>
`,
  },
  {
    id: 5,
    title: "В цеху родилась елочка",
    date: "31.12.2021",
    img: "defaultIcon.png",
    preParagraph:
      "Накануне Нового года в ОАО «Беларускабель» по инициативе профсоюзного комитета прошел творческий конкурс среди структурных подразделений организации «В цеху родилась Ёлочка».",
    paragraph: `<p>Накануне Нового года в ОАО «Беларускабель» по инициативе профсоюзного комитета прошел творческий конкурс среди структурных подразделений организации «В цеху родилась Ёлочка».</p><p>Краше всех оказалась ёлочка, украшенная работниками участка сетевых шнуров производственного цеха. Второе и третье место разделили бухгалтерия и отдел снабжения. Поощрительными   призами отмечены все участники конкурса.</p><p>Администрация, профсоюзный комитет поздравляют всех работников, пенсионеров предприятия, а также жителей и гостей Мозырского района с Новым годом! Желаем мира, добра, благополучия, крепкого здоровья вам и вашим близким!</p>`,
  },
  {
    id: 4,
    title: "ЭТО НАШ ПРАЗДНИК!",
    date: "05.07.2021",
    img: "defaultIcon.png",
    preParagraph:
      "В преддверии Дня Октябрьской революции работники ОАО «Беларускабель» провели субботник по уборке закреплённой территории...",
    paragraph:
      '<p>В преддверии Дня Октябрьской революции работники ОАО «Беларускабель» провели субботник по уборке закреплённой территории, а также привели в порядок захоронения погибших воинов Первой мировой войны и Гражданской войны.</p><img src="/01.jpg"/> <img style="padding-top: 20px" src="/02.jpg"/>',
  },
  {
    id: 3,
    title: "ОТКРЫТИЕ ФЛАГШТОКА",
    date: "05.07.2021",
    img: "defaultIcon.png",
    preParagraph:
      "4 ноября 2022 г. представители ОАО «Беларускабель» приняли участие в диалоговой площадке «Обсуждение законопроекта о всебелорусском народном собрании и внесение изменений в Избирательный кодекс Республики Беларусь», которая прошла в Мозырском драматическом театре имени И.Мележа.",
    paragraph: `<p>4 ноября 2022 г. представители ОАО «Беларускабель» приняли участие в диалоговой площадке «Обсуждение законопроекта о всебелорусском народном собрании и внесение изменений в Избирательный кодекс Республики Беларусь», которая прошла в Мозырском драматическом театре имени И.Мележа.</p>
    <p>В роли экспертов выступили депутат Палаты представителей Национального собрания Республики Беларусь Назаренко В.А., председатель Мозырского районного исполнительного комитета Павлечко Е.Ф., председатель Мозырского районного Совета депутатов Кудина Г.М.
Детально о вносимых на обсуждение нормах законопроекта, роли Всебелорусского народного собрания в системе власти рассказала парламентарий Назаренко В.А.</p>
<p>В ходе мероприятия у присутствующих была возможность задать интересующие их вопросы и получить компетентные ответы.</p><a href="/photogallery">Фотогаллерея</a>`,
  },
  {
    id: 2,
    title: "ЭКСКУРСИОННАЯ ПОЕЗДКА",
    date: "28.06.2021",
    img: "defaultIcon.png",
    preParagraph:
      "30 октября 2022 года работники, члены профсоюзной организации и БРСМ ОАО «Беларускабель» приняли участие в республиканской акции «Символ единства», посвящённой Году исторической памяти.",
    paragraph: `<p>30 октября 2022 года работники, члены профсоюзной организации и БРСМ ОАО «Беларускабель» приняли участие в республиканской акции «Символ единства», 
    посвящённой Году исторической памяти.</p><p>Сначала представители нашего предприятия присоединились к участникам автопробега, которые проехали 118 районов страны, 
    преодолев расстояние в 7 тысяч километров, а в 10 утра стали участниками митинга на мемориальном комплексе «Курган Славы» и возложили цветы к могилам павших героев.
    </p><p>Все маршруты автопробега связала установка возле памятников, мемориалов, посвящённых Великой Отечественной войне, информационных табличек с QR-кодом «Сохраним историю». 
    Такая же табличка появилась теперь и на Мозырщине.</p><p>Символом акции в этом году стала шестерёнка. Все шестерёнки из каждого района соберут вместе, создав единый механизм часы.
     И это – не случайно, ведь все мы –неотъемлемая часть нашей страны. И только совместными усилиями мы можем сделать её крепче.</p><a href="/photogallery">Фотогаллерея</a>`,
  },
  {
    id: 1,
    title: "ЭКСКУРСИОННАЯ ПОЕЗДКА",
    date: "28.06.2021",
    img: "defaultIcon.png",
    preParagraph:
      "25 октября 2022 года в ОАО «Беларускабель» состоялась информационная встреча с трудовым коллективом.",
    paragraph: `<p>25 октября 2022 года в ОАО «Беларускабель» состоялась информационная встреча с трудовым коллективом.</p><p>Перед собравшимися выступила депутат палаты представителей Национального собрания Республики Беларусь Назаренко Валентина Алексеевна, которая осветила тему продовольственной безопасности страны, механизм формирования и регулирования цен, важность развития агропромышленного комплекса.</p>
    <p>Обсуждались также вынесенные на общественное обсуждение два законопроекта:</p>
    <p>проект Закона Республики Беларусь «О Всебелорусском народном собрании»;</p>
    <p>проект Закона Республики Беларусь «Об изменении Избирательного кодекса Республики Беларусь».</p>
    <p>В ходе обсуждения законопроектов Валентина Алексеевна обозначила ключевые подходы к формированию Всебелорусского народного собрания и его органов, а также компетенцию ВНС.</p>
    <p>Директор ОАО «Беларускабель» Шилов Виталий Петрович довел коллективу итоги работы за девять месяцев текущего года и перспективы развития предприятия.</p>
    <p>Представитель государственного предприятия «Стравита» Пчёлка Татьяна Михайловна довела новый механизм добровольного страхования дополнительной накопительной пенсии.</p>
    <p>Заместитель директора по идеологической работе, кадрам и социальным вопросам Фещенко Светлана Леонидовна призвала работников предприятия быть бдительными в условиях участившихся случаев кибермошенничества.</p>
    <p>28 октября с руководителями структурных подразделений предприятия прошла информационная встреча с участием представителя Органов внутренних дел. Были затронуты вопросы профилактики телефонного мошенничества, краж из дач, преступлений против половой неприкосновенности и половой свободы несовершеннолетних.</p>
    <a href="/photogallery">Фотогаллерея</a>`,
  },
];

export const NewsReducer = createSlice({
  name: "news",
  initialState,
  reducers: {},
});

// Action creators are generated for each case reducer function
// export const {increment, decrement, incrementByAmount} = NewsReducer.actions

export default NewsReducer.reducer;
